export enum MeridianStateType {
    AK = "AK", // Alaska
    AL = "AL", // Alabama
    AR = "AR", // Arkansas
    AZ = "AZ", // Arizona
    CA = "CA", // California
    CO = "CO", // Colorado
    CT = "CT", // Connecticut
    DE = "DE", // Delaware
    FL = "FL", // Florida
    GA = "GA", // Georgia
    HI = "HI", // Hawaii
    IA = "IA", // Iowa
    ID = "ID", // Idaho
    IL = "IL", // Illinois
    IN = "IN", // Indiana
    KS = "KS", // Kansas
    KY = "KY", // Kentucky
    LA = "LA", // Louisiana
    MA = "MA", // Massachusetts
    MD = "MD", // Maryland
    ME = "ME", // Maine
    MI = "MI", // Michigan
    MN = "MN", // Minnesota
    MO = "MO", // Missouri
    MS = "MS", // Mississippi
    MT = "MT", // Montana
    NC = "NC", // North Carolina
    ND = "ND", // North Dakota
    NE = "NE", // Nebraska
    NH = "NH", // New Hampshire
    NJ = "NJ", // New Jersey
    NM = "NM", // New Mexico
    NV = "NV", // Nevada
    NY = "NY", // New York
    OH = "OH", // Ohio
    OK = "OK", // Oklahoma
    OR = "OR", // Oregon
    PA = "PA", // Pennsylvania
    RI = "RI", // Rhode Island
    SC = "SC", // South Carolina
    SD = "SD", // South Dakota
    TN = "TN", // Tennessee
    TX = "TX", // Texas
    UT = "UT", // Utah
    VA = "VA", // Virginia
    VT = "VT", // Vermont
    WA = "WA", // Washington
    WI = "WI", // Wisconsin
    WV = "WV", // West Virginia
    WY = "WY"  // Wyoming
}

export enum AK_CountyType {
    ALEUTIANS_EAST = 'Aleutians East',
    ALEUTIANS_WEST = 'Aleutians West',
    ANCHORAGE = 'Anchorage',
    BETHEL = 'Bethel',
    BRISTOL_BAY = 'Bristol Bay',
    DENALI = 'Denali',
    DILLINGHAM = 'Dillingham',
    FAIRBANKS_NORTH_START = 'Fairbanks North Star',
    HAINES = 'Haines',
    HOONAH_ANGOON = 'Hoonah Angoon',
    JUNEAU = 'Juneau',
    KENAI_PENINSULA = 'Kenai Peninsula',
    KETCHIKAN_GATEWAY = 'Ketchikan Gateway',
    KODIAK_ISLAND = 'Kodiak Island',
    KUSILVAK = 'Kusilvak',
    LAKE_AND_PENINSULA = 'Lake And Peninsula',
    MATANUSKA_SUSITNA = 'Matanuska Susitna',
    NOME = 'Nome',
    NORTH_SLOP = 'North Slope',
    NORTHWEST_ARCTIC = 'Northwest Arctic',
    PETERSBURG = 'Petersburg',
    PRINCE_OF_WALES_HYDER = 'Prince Of Wales Hyder',
    SITKA = 'Sitka',
    SKAGWAY = 'Skagway',
    SOUTHEAST_FAIRBANKS = 'Southeast Fairbanks',
    VALDEZ_CORDOVA = 'Valdez Cordova',
    WRANGELL = 'Wrangell',
    YAKUTAT = 'Yakutat',
    YUKON_KOYUKUK = 'Yukon Koyukuk',
}

export enum AL_CountyType {
    AUTAUGA = 'Autauga',
    BALDWIN = 'Baldwin',
    BARBOUR = 'Barbour',
    BIBB = 'Bibb',
    BLOUNT = 'Blount',
    BULLOCK = 'Bullock',
    BUTLER = 'Butler',
    CALHOUN = 'Calhoun',
    CHAMBERS = 'Chambers',
    CHEROKEE = 'Cherokee',
    CHILTON = 'Chilton',
    CHOCTAW = 'Choctaw',
    CLARKE = 'Clarke',
    CLAY = 'Clay',
    CLEBURNE = 'Cleburne',
    COFFEE = 'Coffee',
    COLBERT = 'Colbert',
    CONECUH = 'Conecuh',
    COOSA = 'Coosa',
    COVINGTON = 'Covington',
    CRENSHAW = 'Crenshaw',
    CULLMAN = 'Cullman',
    DALE = 'Dale',
    DALLAS = 'Dallas',
    DE_KALB = 'De Kalb',
    ELMORE = 'Elmore',
    ESCAMBIA = 'Escambia',
    ETOWAH = 'Etowah',
    FAYETTE = 'Fayette',
    FRANKLIN = 'Franklin',
    GENEVA = 'Geneva',
    GREENE = 'Greene',
    HALE = 'Hale',
    HENRY = 'Henry',
    HOUSTON = 'Houston',
    JACKSON = 'Jackson',
    JEFFERSON = 'Jefferson',
    LAMAR = 'Lamar',
    LAUDERDALE = 'Lauderdale',
    LAWRENCE = 'Lawrence',
    LEE = 'Lee',
    LIMESTONE = 'Limestone',
    LOWNDES = 'Lowndes',
    MACON = 'Macon',
    MADISON = 'Madison',
    MARENGO = 'Marengo',
    MARION = 'Marion',
    MARSHALL = 'Marshall',
    MOBILE = 'Mobile',
    MONROE = 'Monroe',
    MONTGOMERY = 'Montgomery',
    MORGAN = 'Morgan',
    PERRY = 'Perry',
    PICKENS = 'Pickens',
    PIKE = 'Pike',
    RANDOLPH = 'Randolph',
    RUSSELL = 'Russell',
    SAINT_CLAIR = 'Saint Clair',
    SHELBY = 'Shelby',
    SUMTER = 'Sumter',
    TALLADEGA = 'Talladega',
    TALLAPOOSA = 'Tallapoosa',
    TUSCALOOSA = 'Tuscaloosa',
    WALKER = 'Walker',
    WASHINGTON = 'Washington',
    WILCOX = 'Wilcox',
    WINSTON = 'Winston',
}

export enum AR_CountyType {
    ARKANSAS = 'Arkansas',
    ASHLEY = 'Ashley',
    BAXTER = 'Baxter',
    BENTON = 'Benton',
    BOONE = 'Boone',
    BRADLEY = 'Bradley',
    CALHOUN = 'Calhoun',
    CARROLL = 'Carroll',
    CHICOT = 'Chicot',
    CLARK = 'Clark',
    CLAY = 'Clay',
    CLEBURNE = 'Cleburne',
    CLEVELAND = 'Cleveland',
    COLUMBIA = 'Columbia',
    CONWAY = 'Conway',
    CRAIGHEAD = 'Craighead',
    CRAWFORD = 'Crawford',
    CRITTENDEN = 'Crittenden',
    CROSS = 'Cross',
    DALLAS = 'Dallas',
    DESHA = 'Desha',
    DREW = 'Drew',
    FAULKNER = 'Faulkner',
    FRANKLIN = 'Franklin',
    FULTON = 'Fulton',
    GARLAND = 'Garland',
    GRANT = 'Grant',
    GREENE = 'Greene',
    HEMPSTEAD = 'Hempstead',
    HOT_SPRING = 'Hot Spring',
    HOWARD = 'Howard',
    INDEPENDENCE = 'Independence',
    IZARD = 'Izard',
    JACKSON = 'Jackson',
    JEFFERSON = 'Jefferson',
    JOHNSON = 'Johnson',
    LAFAYETTE = 'Lafayette',
    LAWRENCE = 'Lawrence',
    LEE = 'Lee',
    LINCOLN = 'Lincoln',
    LITTLE_RIVER = 'Little River',
    LOGAN = 'Logan',
    LONOKE = 'Lonoke',
    MADISON = 'Madison',
    MARION = 'Marion',
    MILLER = 'Miller',
    MISSISSIPPI = 'Mississippi',
    MONROE = 'Monroe',
    MONTGOMERY = 'Montgomery',
    NEVADA = 'Nevada',
    NEWTON = 'Newton',
    OUACHITA = 'Ouachita',
    PERRY = 'Perry',
    PHILLIPS = 'Phillips',
    PIKE = 'Pike',
    POINSETT = 'Poinsett',
    POLK = 'Polk',
    POPE = 'Pope',
    PRAIRIE = 'Prairie',
    PULASKI = 'Pulaski',
    RANDOLPH = 'Randolph',
    SAINT_FRANCIS = 'Saint Francis',
    SALINE = 'Saline',
    SCOTT = 'Scott',
    SEARCY = 'Searcy',
    SEBASTIAN = 'Sebastian',
    SEVIER = 'Sevier',
    SHARP = 'Sharp',
    STONE = 'Stone',
    UNION = 'Union',
    VAN_BUREN = 'Van Buren',
    WASHINGTON = 'Washington',
    WHITE = 'White',
    WOODRUFF = 'Woodruff',
    YELL = 'Yell',
}

export enum AZ_CountyType {
    APACHE = 'Apache',
    COCHISE = 'Cochise',
    COCONINO = 'Coconino',
    GILA = 'Gila',
    GRAHAM = 'Graham',
    GREENLEE = 'Greenlee',
    LA_PAZ = 'La Paz',
    MARICOPA = 'Maricopa',
    MOHAVE = 'Mohave',
    NAVAJO = 'Navajo',
    PIMA = 'Pima',
    PINAL = 'Pinal',
    SANTA_CRUZ = 'Santa Cruz',
    YAVAPAI = 'Yavapai',
    YUMA = 'Yuma',
}

export enum CA_CountyType {
    ALAMEDA = 'Alameda',
    ALPINE = 'Alpine',
    AMADOR = 'Amador',
    BUTTE = 'Butte',
    CALAVERAS = 'Calaveras',
    COLUSA = 'Colusa',
    CONTRA_COSTA = 'Contra Costa',
    DEL_NORTE = 'Del Norte',
    EL_DORADO = 'El Dorado',
    FRESNO = 'Fresno',
    GLENN = 'Glenn',
    HUMBOLDT = 'Humboldt',
    IMPERIAL = 'Imperial',
    INYO = 'Inyo',
    KERN = 'Kern',
    KINGS = 'Kings',
    LAKE = 'Lake',
    LASSEN = 'Lassen',
    LOS_ANGELES = 'Los Angeles',
    MADERA = 'Madera',
    MARIN = 'Marin',
    MARIPOSA = 'Mariposa',
    MENDOCINO = 'Mendocino',
    MERCED = 'Merced',
    MODOC = 'Modoc',
    MONO = 'Mono',
    MONTEREY = 'Monterey',
    NAPA = 'Napa',
    NEVADA = 'Nevada',
    ORANGE = 'Orange',
    PLACER = 'Placer',
    PLUMAS = 'Plumas',
    RIVERSIDE = 'Riverside',
    SACRAMENTO = 'Sacramento',
    SAN_BENITO = 'San Benito',
    SAN_BERNARDINO = 'San Bernardino',
    SAN_DIEGO = 'San Diego',
    SAN_FRANCISCO = 'San Francisco',
    SAN_JOAQUIN = 'San Joaquin',
    SAN_LUIS_OBISPO = 'San Luis Obispo',
    SAN_MATEO = 'San Mateo',
    SANTA_BARBARA = 'Santa Barbara',
    SANTA_CLARA = 'Santa Clara',
    SANTA_CRUZ = 'Santa Cruz',
    SHASTA = 'Shasta',
    SIERRA = 'Sierra',
    SISKIYOU = 'Siskiyou',
    SOLANO = 'Solano',
    SONOMA = 'Sonoma',
    STANISLAUS = 'Stanislaus',
    SUTTER = 'Sutter',
    TEHAMA = 'Tehama',
    TRINITY = 'Trinity',
    TULARE = 'Tulare',
    TUOLUMNE = 'Tuolumne',
    VENTURA = 'Ventura',
    YOLO = 'Yolo',
    YUBA = 'Yuba',
}

export enum CO_CountyType {
    ADAMS = 'Adams',
    ALAMOSA = 'Alamosa',
    ARAPAHOE = 'Arapahoe',
    ARCHULETA = 'Archuleta',
    BACA = 'Baca',
    BENT = 'Bent',
    BOULDER = 'Boulder',
    BROOMFIELD = 'Broomfield',
    CHAFFEE = 'Chaffee',
    CHEYENNE = 'Cheyenne',
    CLEAR_CREEK = 'Clear Creek',
    CONEJOS = 'Conejos',
    COSTILLA = 'Costilla',
    CROWLEY = 'Crowley',
    CUSTER = 'Custer',
    DELTA = 'Delta',
    DENVER = 'Denver',
    DOLORES = 'Dolores',
    DOUGLAS = 'Douglas',
    EAGLE = 'Eagle',
    EL_PASO = 'El Paso',
    ELBERT = 'Elbert',
    FREMONT = 'Fremont',
    GARFIELD = 'Garfield',
    GILPIN = 'Gilpin',
    GRAND = 'Grand',
    GUNNISON = 'Gunnison',
    HINSDALE = 'Hinsdale',
    HUERFANO = 'Huerfano',
    JACKSON = 'Jackson',
    JEFFERSON = 'Jefferson',
    KIOWA = 'Kiowa',
    KIT_CARSON = 'Kit Carson',
    LA_PLATA = 'La Plata',
    LAKE = 'Lake',
    LARIMER = 'Larimer',
    LAS_ANIMAS = 'Las Animas',
    LINCOLN = 'Lincoln',
    LOGAN = 'Logan',
    MESA = 'Mesa',
    MINERAL = 'Mineral',
    MOFFAT = 'Moffat',
    MONTEZUMA = 'Montezuma',
    MONTROSE = 'Montrose',
    MORGAN = 'Morgan',
    OTERO = 'Otero',
    OURAY = 'Ouray',
    PARK = 'Park',
    PHILLIPS = 'Phillips',
    PITKIN = 'Pitkin',
    PROWERS = 'Prowers',
    PUEBLO = 'Pueblo',
    RIO_BLANCO = 'Rio Blanco',
    RIO_GRANDE = 'Rio Grande',
    ROUTT = 'Routt',
    SAGUACHE = 'Saguache',
    SAN_JUAN = 'San Juan',
    SAN_MIGUEL = 'San Miguel',
    SEDGWICK = 'Sedgwick',
    SUMMIT = 'Summit',
    TELLER = 'Teller',
    WASHINGTON = 'Washington',
    WELD = 'Weld',
    YUMA = 'Yuma',
}

export enum CT_CountyType {
    FAIRFIELD = 'Fairfield',
    HARTFORD = 'Hartford',
    LITCHFIELD = 'Litchfield',
    MIDDLESEX = 'Middlesex',
    NEW_HAVEN = 'New Haven',
    NEW_LONDON = 'New London',
    TOLLAND = 'Tolland',
    WINDHAM = 'Windham',
}

export enum DE_CountyType {
    KENT = 'Kent',
    NEW_CASTLE = 'New Castle',
    SUSSEX = 'Sussex',
}

export enum FL_CountyType {
    ALACHUA = 'Alachua',
    BAKER = 'Baker',
    BAY = 'Bay',
    BRADFORD = 'Bradford',
    BREVARD = 'Brevard',
    BROWARD = 'Broward',
    CALHOUN = 'Calhoun',
    CHARLOTTE = 'Charlotte',
    CITRUS = 'Citrus',
    CLAY = 'Clay',
    COLLIER = 'Collier',
    COLUMBIA = 'Columbia',
    DE_SOTO = 'De Soto',
    DIXIE = 'Dixie',
    DUVAL = 'Duval',
    ESCAMBIA = 'Escambia',
    FLAGLER = 'Flagler',
    FRANKLIN = 'Franklin',
    GADSDEN = 'Gadsden',
    GILCHRIST = 'Gilchrist',
    GLADES = 'Glades',
    GULF = 'Gulf',
    HAMILTON = 'Hamilton',
    HARDEE = 'Hardee',
    HENDRY = 'Hendry',
    HERNANDO = 'Hernando',
    HIGHLANDS = 'Highlands',
    HILLSBOROUGH = 'Hillsborough',
    HOLMES = 'Holmes',
    INDIAN_RIVER = 'Indian River',
    JACKSON = 'Jackson',
    JEFFERSON = 'Jefferson',
    LAFAYETTE = 'Lafayette',
    LAKE = 'Lake',
    LEE = 'Lee',
    LEON = 'Leon',
    LEVY = 'Levy',
    LIBERTY = 'Liberty',
    MADISON = 'Madison',
    MANATEE = 'Manatee',
    MARION = 'Marion',
    MARTIN = 'Martin',
    MIAMI_DADE = 'Miami-Dade',
    MONROE = 'Monroe',
    NASSAU = 'Nassau',
    OKALOOSA = 'Okaloosa',
    OKEECHOBEE = 'Okeechobee',
    ORANGE = 'Orange',
    OSCEOLA = 'Osceola',
    PALM_BEACH = 'Palm Beach',
    PASCO = 'Pasco',
    PINELLAS = 'Pinellas',
    POLK = 'Polk',
    PUTNAM = 'Putnam',
    SAINT_JOHNS = 'Saint Johns',
    SAINT_LUCIE = 'Saint Lucie',
    SANTA_ROSA = 'Santa Rosa',
    SARASOTA = 'Sarasota',
    SEMINOLE = 'Seminole',
    SUMTER = 'Sumter',
    SUWANNEE = 'Suwannee',
    TAYLOR = 'Taylor',
    UNION = 'Union',
    VOLUSIA = 'Volusia',
    WAKULLA = 'Wakulla',
    WALTON = 'Walton',
    WASHINGTON = 'Washington',
}

export enum GA_CountyType {
    APPLING = 'Appling',
    ATKINSON = 'Atkinson',
    BACON = 'Bacon',
    BAKER = 'Baker',
    BALDWIN = 'Baldwin',
    BANKS = 'Banks',
    BARROW = 'Barrow',
    BARTOW = 'Bartow',
    BEN_HILL = 'Ben Hill',
    BERRIEN = 'Berrien',
    BIBB = 'Bibb',
    BLECKLEY = 'Bleckley',
    BRANTLEY = 'Brantley',
    BROOKS = 'Brooks',
    BRYAN = 'Bryan',
    BULLOCH = 'Bulloch',
    BURKE = 'Burke',
    BUTTS = 'Butts',
    CALHOUN = 'Calhoun',
    CAMDEN = 'Camden',
    CANDLER = 'Candler',
    CARROLL = 'Carroll',
    CATOOSA = 'Catoosa',
    CHARLTON = 'Charlton',
    CHATHAM = 'Chatham',
    CHATTAHOOCHEE = 'Chattahoochee',
    CHATTOOGA = 'Chattooga',
    CHEROKEE = 'Cherokee',
    CLARKE = 'Clarke',
    CLAY = 'Clay',
    CLAYTON = 'Clayton',
    CLINCH = 'Clinch',
    COBB = 'Cobb',
    COFFEE = 'Coffee',
    COLQUITT = 'Colquitt',
    COLUMBIA = 'Columbia',
    COOK = 'Cook',
    COWETA = 'Coweta',
    CRAWFORD = 'Crawford',
    CRISP = 'Crisp',
    DADE = 'Dade',
    DAWSON = 'Dawson',
    DECATUR = 'Decatur',
    DEKALB = 'Dekalb',
    DODGE = 'Dodge',
    DOOLY = 'Dooly',
    DOUGHERTY = 'Dougherty',
    DOUGLAS = 'Douglas',
    EARLY = 'Early',
    ECHOLS = 'Echols',
    EFFINGHAM = 'Effingham',
    ELBERT = 'Elbert',
    EMANUEL = 'Emanuel',
    EVANS = 'Evans',
    FANNIN = 'Fannin',
    FAYETTE = 'Fayette',
    FLOYD = 'Floyd',
    FORSYTH = 'Forsyth',
    FRANKLIN = 'Franklin',
    FULTON = 'Fulton',
    GILMER = 'Gilmer',
    GLASCOCK = 'Glascock',
    GLYNN = 'Glynn',
    GORDON = 'Gordon',
    GRADY = 'Grady',
    GREENE = 'Greene',
    GWINNETT = 'Gwinnett',
    HABERSHAM = 'Habersham',
    HALL = 'Hall',
    HANCOCK = 'Hancock',
    HARALSON = 'Haralson',
    HARRIS = 'Harris',
    HART = 'Hart',
    HEARD = 'Heard',
    HENRY = 'Henry',
    HOUSTON = 'Houston',
    IRWIN = 'Irwin',
    JACKSON = 'Jackson',
    JASPER = 'Jasper',
    JEFF_DAVIS = 'Jeff Davis',
    JEFFERSON = 'Jefferson',
    JENKINS = 'Jenkins',
    JOHNSON = 'Johnson',
    JONES = 'Jones',
    LAMAR = 'Lamar',
    LANIER = 'Lanier',
    LAURENS = 'Laurens',
    LEE = 'Lee',
    LIBERTY = 'Liberty',
    LINCOLN = 'Lincoln',
    LONG = 'Long',
    LOWNDES = 'Lowndes',
    LUMPKIN = 'Lumpkin',
    MACON = 'Macon',
    MADISON = 'Madison',
    MARION = 'Marion',
    MCDUFFIE = 'Mcduffie',
    MCINTOSH = 'Mcintosh',
    MERIWETHER = 'Meriwether',
    MILLER = 'Miller',
    MITCHELL = 'Mitchell',
    MONROE = 'Monroe',
    MONTGOMERY = 'Montgomery',
    MORGAN = 'Morgan',
    MURRAY = 'Murray',
    MUSCOGEE = 'Muscogee',
    NEWTON = 'Newton',
    OCONEE = 'Oconee',
    OGELTHORPE = 'Oglethorpe',
    PAULDING = 'Paulding',
    PEACH = 'Peach',
    PICKENS = 'Pickens',
    PIERCE = 'Pierce',
    PIKE = 'Pike',
    POLK = 'Polk',
    PULASKI = 'Pulaski',
    PUTNAM = 'Putnam',
    QUITMAN = 'Quitman',
    RABUN = 'Rabun',
    RANDOLPH = 'Randolph',
    RICHMOND = 'Richmond',
    ROCKDALE = 'Rockdale',
    SCHLEY = 'Schley',
    SCREVEN = 'Screven',
    SEMINOLE = 'Seminole',
    SPALDING = 'Spalding',
    STEPHENS = 'Stephens',
    STEWART = 'Stewart',
    SUMTER = 'Sumter',
    TALBOT = 'Talbot',
    TALIAFERRO = 'Taliaferro',
    TATTNALL = 'Tattnall',
    TAYLOR = 'Taylor',
    TELFAIR = 'Telfair',
    TERRELL = 'Terrell',
    THOMAS = 'Thomas',
    TIFT = 'Tift',
    TOOMBS = 'Toombs',
    TOWNS = 'Towns',
    TREUTLEN = 'Treutlen',
    TROUP = 'Troup',
    TURNER = 'Turner',
    TWIGGS = 'Twiggs',
    UNION = 'Union',
    UPSON = 'Upson',
    WALKER = 'Walker',
    WALTON = 'Walton',
    WARE = 'Ware',
    WARREN = 'Warren',
    WASHINGTON = 'Washington',
    WAYNE = 'Wayne',
    WEBSTER = 'Webster',
    WHEELER = 'Wheeler',
    WHITE = 'White',
    WHITFIELD = 'Whitfield',
    WILCOX = 'Wilcox',
    WILKES = 'Wilkes',
    WILKINSON = 'Wilkinson',
    WORTH = 'Worth',
}

export enum HI_CountyType {
    HAWAII = 'Hawaii',
    HONOLULU = 'Honolulu',
    KAUAI = 'Kauai',
    MAUI = 'Maui',
}

export enum IA_CountyType {
    ADAIR = 'Adair',
    ADAMS = 'Adams',
    ALLAMAKEE = 'Allamakee',
    APPANOOSE = 'Appanoose',
    AUDUBON = 'Audubon',
    BENTON = 'Benton',
    BLACK_HAWK = 'Black Hawk',
    BOONE = 'Boone',
    BREMER = 'Bremer',
    BUCHANAN = 'Buchanan',
    BUENA_VISTA = 'Buena Vista',
    BUTLER = 'Butler',
    CALHOUN = 'Calhoun',
    CARROLL = 'Carroll',
    CASS = 'Cass',
    CEDAR = 'Cedar',
    CERRO_GORDO = 'Cerro Gordo',
    CHEROKEE = 'Cherokee',
    CHICKASAW = 'Chickasaw',
    CLARKE = 'Clarke',
    CLAY = 'Clay',
    CLAYTON = 'Clayton',
    CLINTON = 'Clinton',
    CRAWFORD = 'Crawford',
    DALLAS = 'Dallas',
    DAVIS = 'Davis',
    DECATUR = 'Decatur',
    DELAWARE = 'Delaware',
    DES_MOINES = 'Des Moines',
    DICKINSON = 'Dickinson',
    DUBUQUE = 'Dubuque',
    EMMET = 'Emmet',
    FAYETTE = 'Fayette',
    FLOYD = 'Floyd',
    FRANKLIN = 'Franklin',
    FREMONT = 'Fremont',
    GREENE = 'Greene',
    GRUNDY = 'Grundy',
    GUTHRIE = 'Guthrie',
    HAMILTON = 'Hamilton',
    HANCOCK = 'Hancock',
    HARDIN = 'Hardin',
    HARRISON = 'Harrison',
    HENRY = 'Henry',
    HOWARD = 'Howard',
    HUMBOLDT = 'Humboldt',
    IDA = 'Ida',
    IOWA = 'Iowa',
    JACKSON = 'Jackson',
    JASPER = 'Jasper',
    JEFFERSON = 'Jefferson',
    JOHNSON = 'Johnson',
    JONES = 'Jones',
    KEOKUK = 'Keokuk',
    KOSSUTH = 'Kossuth',
    LEE = 'Lee',
    LINN = 'Linn',
    LOUISA = 'Louisa',
    LUCAS = 'Lucas',
    LYON = 'Lyon',
    MADISON = 'Madison',
    MAHASKA = 'Mahaska',
    MARION = 'Marion',
    MARSHALL = 'Marshall',
    MILLS = 'Mills',
    MITCHELL = 'Mitchell',
    MONONA = 'Monona',
    MONROE = 'Monroe',
    MONTGOMERY = 'Montgomery',
    MUSCATINE = 'Muscatine',
    OBRIEN = 'Obrien',
    OSCEOLA = 'Osceola',
    PAGE = 'Page',
    PALO_ALTO = 'Palo Alto',
    PLYMOUTH = 'Plymouth',
    POCAHONTAS = 'Pocahontas',
    POLK = 'Polk',
    POTTAWATTAMIE = 'Pottawattamie',
    POWESHIEK = 'Poweshiek',
    RINGGOLD = 'Ringgold',
    SAC = 'Sac',
    SCOTT = 'Scott',
    SHELBY = 'Shelby',
    SIOUX = 'Sioux',
    STORY = 'Story',
    TAMA = 'Tama',
    TAYLOR = 'Taylor',
    UNION = 'Union',
    VAN_BUREN = 'Van Buren',
    WAPELLO = 'Wapello',
    WARREN = 'Warren',
    WASHINGTON = 'Washington',
    WAYNE = 'Wayne',
    WEBSTER = 'Webster',
    WINNEBAGO = 'Winnebago',
    WINNESHIEK = 'Winneshiek',
    WOODBURY = 'Woodbury',
    WORTH = 'Worth',
    WRIGHT = 'Wright',
}

export enum ID_CountyType {
    ADA = 'Ada',
    ADAMS = 'Adams',
    BANNOCK = 'Bannock',
    BEAR_LAKE = 'Bear Lake',
    BENEWAH = 'Benewah',
    BINGHAM = 'Bingham',
    BLAINE = 'Blaine',
    BOISE = 'Boise',
    BONNER = 'Bonner',
    BONNEVILLE = 'Bonneville',
    BOUNDARY = 'Boundary',
    BUTTE = 'Butte',
    CAMAS = 'Camas',
    CANYON = 'Canyon',
    CARIBOU = 'Caribou',
    CASSIA = 'Cassia',
    CLARK = 'Clark',
    CLEARWATER = 'Clearwater',
    CUSTER = 'Custer',
    ELMORE = 'Elmore',
    FRANKLIN = 'Franklin',
    FREMONT = 'Fremont',
    GEM = 'Gem',
    GOODING = 'Gooding',
    IDAHO = 'Idaho',
    JEFFERSON = 'Jefferson',
    JEROME = 'Jerome',
    KOOTENAI = 'Kootenai',
    LATAH = 'Latah',
    LEMHI = 'Lemhi',
    LEWIS = 'Lewis',
    LINCOLN = 'Lincoln',
    MADISON = 'Madison',
    MINIDOKA = 'Minidoka',
    NEZ_PERCES = 'Nez Perce',
    ONEIDA = 'Oneida',
    OWYHEE = 'Owyhee',
    PAYETTE = 'Payette',
    POWER = 'Power',
    SHOSHONE = 'Shoshone',
    TETON = 'Teton',
    TWIN_FALLS = 'Twin Falls',
    VALLEY = 'Valley',
    WASHINGTON = 'Washington',
}

export enum IL_CountyType {
    ADAMS = 'Adams',
    ALEXANDER = 'Alexander',
    BOND = 'Bond',
    BOONE = 'Boone',
    BROWN = 'Brown',
    BUREAU = 'Bureau',
    CALHOUN = 'Calhoun',
    CARROLL = 'Carroll',
    CASS = 'Cass',
    CHAMPAIGN = 'Champaign',
    CHRISTIAN = 'Christian',
    CLARK = 'Clark',
    CLAY = 'Clay',
    CLINTON = 'Clinton',
    COLES = 'Coles',
    COOK = 'Cook',
    CRAWFORD = 'Crawford',
    CUMBERLAND = 'Cumberland',
    DEKALB = 'Dekalb',
    DEWITT = 'Dewitt',
    DOUGLAS = 'Douglas',
    DUPAGE = 'Dupage',
    EDGAR = 'Edgar',
    EDWARDS = 'Edwards',
    EFFINGHAM = 'Effingham',
    FAYETTE = 'Fayette',
    FORD = 'Ford',
    FRANKLIN = 'Franklin',
    FULTON = 'Fulton',
    GALLATIN = 'Gallatin',
    GREENE = 'Greene',
    GRUNDY = 'Grundy',
    HAMILTON = 'Hamilton',
    HANCOCK = 'Hancock',
    HARDIN = 'Hardin',
    HENDERSON = 'Henderson',
    HENRY = 'Henry',
    IROQUOIS = 'Iroquois',
    JACKSON = 'Jackson',
    JASPER = 'Jasper',
    JEFFERSON = 'Jefferson',
    JERSEY = 'Jersey',
    JO_DAVIESS = 'Jo Daviess',
    JOHNSON = 'Johnson',
    KANE = 'Kane',
    KANKAKEE = 'Kankakee',
    KENDALL = 'Kendall',
    KNOX = 'Knox',
    LA_SALLE = 'La Salle',
    LAKE = 'Lake',
    LAWRENCE = 'Lawrence',
    LEE = 'Lee',
    LIVINGSTON = 'Livingston',
    LOGAN = 'Logan',
    MACON = 'Macon',
    MACOUPIN = 'Macoupin',
    MADISON = 'Madison',
    MARION = 'Marion',
    MARSHALL = 'Marshall',
    MASON = 'Mason',
    MASSAC = 'Massac',
    MCDONOUGH = 'Mcdonough',
    MCHENRY = 'Mchenry',
    MCLEAN = 'Mclean',
    MENARD = 'Menard',
    MERCER = 'Mercer',
    MONROE = 'Monroe',
    MONTGOMERY = 'Montgomery',
    MORGAN = 'Morgan',
    MOULTRIE = 'Moultrie',
    OGLE = 'Ogle',
    PEORIA = 'Peoria',
    PERRY = 'Perry',
    PIATT = 'Piatt',
    PIKE = 'Pike',
    POPE = 'Pope',
    PULASKI = 'Pulaski',
    PUTNAM = 'Putnam',
    RANDOLPH = 'Randolph',
    RICHLAND = 'Richland',
    ROCK_ISLAND = 'Rock Island',
    SAINT_CLAIR = 'Saint Clair',
    SALINE = 'Saline',
    SANGAMON = 'Sangamon',
    SCHUYLER = 'Schuyler',
    SCOTT = 'Scott',
    SHELBY = 'Shelby',
    STARK = 'Stark',
    STEPHENSON = 'Stephenson',
    TAZEWELL = 'Tazewell',
    UNION = 'Union',
    VERMILION = 'Vermilion',
    WABASH = 'Wabash',
    WARREN = 'Warren',
    WASHINGTON = 'Washington',
    WAYNE = 'Wayne',
    WHITE = 'White',
    WHITESIDE = 'Whiteside',
    WILL = 'Will',
    WILLIAMSON = 'Williamson',
    WINNEBAGO = 'Winnebago',
    WOODFORD = 'Woodford',
}

export enum IN_CountyType {
    ADAMS = 'Adams',
    ALLEN = 'Allen',
    BARTHOLOMEW = 'Bartholomew',
    BENTON = 'Benton',
    BLACKFORD = 'Blackford',
    BOONE = 'Boone',
    BROWN = 'Brown',
    CARROLL = 'Carroll',
    CASS = 'Cass',
    CLARK = 'Clark',
    CLAY = 'Clay',
    CLINTON = 'Clinton',
    CRAWFORD = 'Crawford',
    DAVIESS = 'Daviess',
    DE_KALB = 'De Kalb',
    DEARBORN = 'Dearborn',
    DECATUR = 'Decatur',
    DELAWARE = 'Delaware',
    DUBOIS = 'Dubois',
    ELKHART = 'Elkhart',
    FAYETTE = 'Fayette',
    FLOYD = 'Floyd',
    FOUNTAIN = 'Fountain',
    FRANKLIN = 'Franklin',
    FULTON = 'Fulton',
    GIBSON = 'Gibson',
    GRANT = 'Grant',
    GREENE = 'Greene',
    HAMILTON = 'Hamilton',
    HANCOCK = 'Hancock',
    HARRISON = 'Harrison',
    HENDRICKS = 'Hendricks',
    HENRY = 'Henry',
    HOWARD = 'Howard',
    HUNTINGTON = 'Huntington',
    JACKSON = 'Jackson',
    JASPER = 'Jasper',
    JAY = 'Jay',
    JEFFERSON = 'Jefferson',
    JENNINGS = 'Jennings',
    JOHNSON = 'Johnson',
    KNOX = 'Knox',
    KOSCIUSKO = 'Kosciusko',
    LA_PORTE = 'La Porte',
    LAGRANGE = 'Lagrange',
    LAKE = 'Lake',
    LAWRENCE = 'Lawrence',
    MADISON = 'Madison',
    MARION = 'Marion',
    MARSHALL = 'Marshall',
    MARTIN = 'Martin',
    MIAMI = 'Miami',
    MONROE = 'Monroe',
    MONTGOMERY = 'Montgomery',
    MORGAN = 'Morgan',
    NEWTON = 'Newton',
    NOBLE = 'Noble',
    OHIO = 'Ohio',
    ORANGE = 'Orange',
    OWEN = 'Owen',
    PARKE = 'Parke',
    PERRY = 'Perry',
    PIKE = 'Pike',
    PORTER = 'Porter',
    POSEY = 'Posey',
    PULASKI = 'Pulaski',
    PUTNAM = 'Putnam',
    RANDOLPH = 'Randolph',
    RIPLEY = 'Ripley',
    RUSH = 'Rush',
    SCOTT = 'Scott',
    SHELBY = 'Shelby',
    SPENCER = 'Spencer',
    ST_JOSEPH = 'St Joseph',
    STARKE = 'Starke',
    STEUBEN = 'Steuben',
    SULLIVAN = 'Sullivan',
    SWITZERLAND = 'Switzerland',
    TIPPECANOE = 'Tippecanoe',
    TIPTON = 'Tipton',
    UNION = 'Union',
    VANDERBURGH = 'Vanderburgh',
    VERMILLION = 'Vermillion',
    VIGO = 'Vigo',
    WABASH = 'Wabash',
    WARREN = 'Warren',
    WARRICK = 'Warrick',
    WASHINGTON = 'Washington',
    WAYNE = 'Wayne',
    WELLS = 'Wells',
    WHITE = 'White',
    WHITLEY = 'Whitley',
}

export enum KS_CountyType {
    ALLEN = 'Allen',
    ANDERSON = 'Anderson',
    ATCHISON = 'Atchison',
    BARBER = 'Barber',
    BARTON = 'Barton',
    BOURBON = 'Bourbon',
    BROWN = 'Brown',
    BUTLER = 'Butler',
    CHASE = 'Chase',
    CHAUTAUQUA = 'Chautauqua',
    CHEROKEE = 'Cherokee',
    CHEYENNE = 'Cheyenne',
    CLARK = 'Clark',
    CLAY = 'Clay',
    CLOUD = 'Cloud',
    COFFEY = 'Coffey',
    COMANCHE = 'Comanche',
    COWLEY = 'Cowley',
    CRAWFORD = 'Crawford',
    DECATUR = 'Decatur',
    DICKINSON = 'Dickinson',
    DONIPHAN = 'Doniphan',
    DOUGLAS = 'Douglas',
    EDWARDS = 'Edwards',
    ELK = 'Elk',
    ELLIS = 'Ellis',
    ELLSWORTH = 'Ellsworth',
    FINNEY = 'Finney',
    FORD = 'Ford',
    FRANKLIN = 'Franklin',
    GEARY = 'Geary',
    GOVE = 'Gove',
    GRAHAM = 'Graham',
    GRANT = 'Grant',
    GRAY = 'Gray',
    GREELEY = 'Greeley',
    GREENWOOD = 'Greenwood',
    HAMILTON = 'Hamilton',
    HARPER = 'Harper',
    HARVEY = 'Harvey',
    HASKELL = 'Haskell',
    HODGEMAN = 'Hodgeman',
    JACKSON = 'Jackson',
    JEFFERSON = 'Jefferson',
    JEWELL = 'Jewell',
    JOHNSON = 'Johnson',
    KEARNY = 'Kearny',
    KINGMAN = 'Kingman',
    KIOWA = 'Kiowa',
    LABETTE = 'Labette',
    LANE = 'Lane',
    LEAVENWORTH = 'Leavenworth',
    LINCOLN = 'Lincoln',
    LINN = 'Linn',
    LOGAN = 'Logan',
    LYON = 'Lyon',
    MARION = 'Marion',
    MARSHALL = 'Marshall',
    MCPHERSON = 'Mcpherson',
    MEADE = 'Meade',
    MIAMI = 'Miami',
    MITCHELL = 'Mitchell',
    MONTGOMERY = 'Montgomery',
    MORRIS = 'Morris',
    MORTON = 'Morton',
    NEMAHA = 'Nemaha',
    NEOSHO = 'Neosho',
    NESS = 'Ness',
    NORTON = 'Norton',
    OSAGE = 'Osage',
    OSBORNE = 'Osborne',
    OTTAWA = 'Ottawa',
    PAWNEE = 'Pawnee',
    PHILLIPS = 'Phillips',
    POTTAWATOMIE = 'Pottawatomie',
    PRATT = 'Pratt',
    RAWLINS = 'Rawlins',
    RENO = 'Reno',
    REPUBLIC = 'Republic',
    RICE = 'Rice',
    RILEY = 'Riley',
    ROOKS = 'Rooks',
    RUSH = 'Rush',
    RUSSELL = 'Russell',
    SALINE = 'Saline',
    SCOTT = 'Scott',
    SEDGWICK = 'Sedgwick',
    SEWARD = 'Seward',
    SHAWNEE = 'Shawnee',
    SHERIDAN = 'Sheridan',
    SHERMAN = 'Sherman',
    SMITH = 'Smith',
    STAFFORD = 'Stafford',
    STANTON = 'Stanton',
    STEVENS = 'Stevens',
    SUMNER = 'Sumner',
    THOMAS = 'Thomas',
    TREGO = 'Trego',
    WABAUNSEE = 'Wabaunsee',
    WALLACE = 'Wallace',
    WASHINGTON = 'Washington',
    WICHITA = 'Wichita',
    WILSON = 'Wilson',
    WOODSON = 'Woodson',
    WYANDOTTE = 'Wyandotte',
}

export enum KY_CountyType {
    ADAIR = 'Adair',
    ALLEN = 'Allen',
    ANDERSON = 'Anderson',
    BALLARD = 'Ballard',
    BARREN = 'Barren',
    BATH = 'Bath',
    BELL = 'Bell',
    BOONE = 'Boone',
    BOURBON = 'Bourbon',
    BOYD = 'Boyd',
    BOYLE = 'Boyle',
    BRACKEN = 'Bracken',
    BREATHITT = 'Breathitt',
    BRECKINRIDGE = 'Breckinridge',
    BULLITT = 'Bullitt',
    BUTLER = 'Butler',
    CALDWELL = 'Caldwell',
    CALLOWAY = 'Calloway',
    CAMPBELL = 'Campbell',
    CARLISLE = 'Carlisle',
    CARROLL = 'Carroll',
    CARTER = 'Carter',
    CASEY = 'Casey',
    CHRISTIAN = 'Christian',
    CLARK = 'Clark',
    CLAY = 'Clay',
    CLINTON = 'Clinton',
    CRITTENDEN = 'Crittenden',
    CUMBERLAND = 'Cumberland',
    DAVIESS = 'Daviess',
    EDMONSON = 'Edmonson',
    ELLIOTT = 'Elliott',
    ESTILL = 'Estill',
    FAYETTE = 'Fayette',
    FLEMING = 'Fleming',
    FLOYD = 'Floyd',
    FRANKLIN = 'Franklin',
    FULTON = 'Fulton',
    GALLATIN = 'Gallatin',
    GARRARD = 'Garrard',
    GRANT = 'Grant',
    GRAVES = 'Graves',
    GRAYSON = 'Grayson',
    GREEN = 'Green',
    GREENUP = 'Greenup',
    HANCOCK = 'Hancock',
    HARDIN = 'Hardin',
    HARLAN = 'Harlan',
    HARRISON = 'Harrison',
    HART = 'Hart',
    HENDERSON = 'Henderson',
    HENRY = 'Henry',
    HICKMAN = 'Hickman',
    HOPKINS = 'Hopkins',
    JACKSON = 'Jackson',
    JEFFERSON = 'Jefferson',
    JESSAMINE = 'Jessamine',
    JOHNSON = 'Johnson',
    KENTON = 'Kenton',
    KNOTT = 'Knott',
    KNOX = 'Knox',
    LARUE = 'Larue',
    LAUREL = 'Laurel',
    LAWRENCE = 'Lawrence',
    LEE = 'Lee',
    LESLIE = 'Leslie',
    LETCHER = 'Letcher',
    LEWIS = 'Lewis',
    LINCOLN = 'Lincoln',
    LIVINGSTON = 'Livingston',
    LOGAN = 'Logan',
    LYON = 'Lyon',
    MADISON = 'Madison',
    MAGOFFIN = 'Magoffin',
    MARION = 'Marion',
    MARSHALL = 'Marshall',
    MARTIN = 'Martin',
    MASON = 'Mason',
    MCCRACKEN = 'Mccracken',
    MCCREARY = 'Mccreary',
    MCLEAN = 'Mclean',
    MEADE = 'Meade',
    MENIFEE = 'Menifee',
    MERCER = 'Mercer',
    METCALFE = 'Metcalfe',
    MONROE = 'Monroe',
    MONTGOMERY = 'Montgomery',
    MORGAN = 'Morgan',
    MUHLENBERG = 'Muhlenberg',
    NELSON = 'Nelson',
    NICHOLAS = 'Nicholas',
    OHIO = 'Ohio',
    OLDHAM = 'Oldham',
    OWEN = 'Owen',
    OWSLEY = 'Owsley',
    PENDLETON = 'Pendleton',
    PERRY = 'Perry',
    PIKE = 'Pike',
    POWELL = 'Powell',
    PULASKI = 'Pulaski',
    ROBERTSON = 'Robertson',
    ROCKCASTLE = 'Rockcastle',
    ROWAN = 'Rowan',
    RUSSELL = 'Russell',
    SCOTT = 'Scott',
    SHELBY = 'Shelby',
    SIMPSON = 'Simpson',
    SPENCER = 'Spencer',
    TAYLOR = 'Taylor',
    TODD = 'Todd',
    TRIGG = 'Trigg',
    TRIMBLE = 'Trimble',
    UNION = 'Union',
    WARREN = 'Warren',
    WASHINGTON = 'Washington',
    WAYNE = 'Wayne',
    WEBSTER = 'Webster',
    WHITLEY = 'Whitley',
    WOLFE = 'Wolfe',
    WOODFORD = 'Woodford',
}

export enum LA_CountyType {
    ACADIA = 'Acadia',
    ALLEN = 'Allen',
    ASCENSION = 'Ascension',
    ASSUMPTION = 'Assumption',
    AVOYELLES = 'Avoyelles',
    BEAUREGARD = 'Beauregard',
    BIENVILLE = 'Bienville',
    BOSSIER = 'Bossier',
    CADDO = 'Caddo',
    CALCASIEU = 'Calcasieu',
    CALDWELL = 'Caldwell',
    CAMERON = 'Cameron',
    CATAHOULA = 'Catahoula',
    CLAIBORNE = 'Claiborne',
    CONCORDIA = 'Concordia',
    DE_SOTO = 'De Soto',
    EAST_BATON_ROUGE = 'East Baton Rouge',
    EAST_CARROLL = 'East Carroll',
    EAST_FELICIANA = 'East Feliciana',
    EVANGELINE = 'Evangeline',
    FRANKLIN = 'Franklin',
    GRANT = 'Grant',
    IBERIA = 'Iberia',
    IBERVILLE = 'Iberville',
    JACKSON = 'Jackson',
    JEFFERSON = 'Jefferson',
    JEFFERSON_DAVIS = 'Jefferson Davis',
    LA_SALLE = 'La Salle',
    LAFAYETTE = 'Lafayette',
    LAFOURCHE = 'Lafourche',
    LINCOLN = 'Lincoln',
    LIVINGSTON = 'Livingston',
    MADISON = 'Madison',
    MOREHOUSE = 'Morehouse',
    NATCHITOCHES = 'Natchitoches',
    ORLEANS = 'Orleans',
    OUACHITA = 'Ouachita',
    PLAQUEMINES = 'Plaquemines',
    POINTE_COUPEE = 'Pointe Coupee',
    RAPIDES = 'Rapides',
    RED_RIVER = 'Red River',
    RICHLAND = 'Richland',
    SABINE = 'Sabine',
    SAINT_BERNARD = 'Saint Bernard',
    SAINT_CHARLES = 'Saint Charles',
    SAINT_HELENA = 'Saint Helena',
    SAINT_JAMES = 'Saint James',
    SAINT_LANDRY = 'Saint Landry',
    SAINT_MARTIN = 'Saint Martin',
    SAINT_MARY = 'Saint Mary',
    SAINT_TAMMANY = 'Saint Tammany',
    ST_JOHN_THE_BAPTIST = 'St John The Baptist',
    TANGIPAHOA = 'Tangipahoa',
    TENSAS = 'Tensas',
    TERREBONNE = 'Terrebonne',
    UNION = 'Union',
    VERMILION = 'Vermilion',
    VERNON = 'Vernon',
    WASHINGTON = 'Washington',
    WEBSTER = 'Webster',
    WEST_BATON_ROUGE = 'West Baton Rouge',
    WEST_CARROLL = 'West Carroll',
    WEST_FELICIANA = 'West Feliciana',
    WINN = 'Winn',
}

export enum MA_CountyType {
    BARNSTABLE = 'Barnstable',
    BERKSHIRE = 'Berkshire',
    BRISTOL = 'Bristol',
    DUKES = 'Dukes',
    ESSEX = 'Essex',
    FRANKLIN = 'Franklin',
    HAMPDEN = 'Hampden',
    HAMPSHIRE = 'Hampshire',
    MIDDLESEX = 'Middlesex',
    NANTUCKET = 'Nantucket',
    NORFOLK = 'Norfolk',
    PLYMOUTH = 'Plymouth',
    SUFFOLK = 'Suffolk',
    WORCESTER = 'Worcester',
}

export enum MD_CountyType {
    ALLEGANY = 'Allegany',
    ANNE_ARUNDEL = 'Anne Arundel',
    BALTIMORE = 'Baltimore',
    BALTIMORE_CITY = 'Baltimore City',
    CALVERT = 'Calvert',
    CAROLINE = 'Caroline',
    CARROLL = 'Carroll',
    CECIL = 'Cecil',
    CHARLES = 'Charles',
    DORCHESTER = 'Dorchester',
    FREDERICK = 'Frederick',
    GARRETT = 'Garrett',
    HARFORD = 'Harford',
    HOWARD = 'Howard',
    KENT = 'Kent',
    MONTGOMERY = 'Montgomery',
    PRINCE_GEORGES = 'Prince Georges',
    QUEEN_ANNES = 'Queen Annes',
    SAINT_MARYS = 'Saint Marys',
    SOMERSET = 'Somerset',
    TALBOT = 'Talbot',
    WASHINGTON = 'Washington',
    WICOMICO = 'Wicomico',
    WORCESTER = 'Worcester',
}

export enum ME_CountyType {
    ANDROSCOGGIN = 'Androscoggin',
    AROOSTOOK = 'Aroostook',
    CUMBERLAND = 'Cumberland',
    FRANKLIN = 'Franklin',
    HANCOCK = 'Hancock',
    KENNEBEC = 'Kennebec',
    KNOX = 'Knox',
    LINCOLN = 'Lincoln',
    OXFORD = 'Oxford',
    PENOBSCOT = 'Penobscot',
    PISCATAQUIS = 'Piscataquis',
    SAGADAHOC = 'Sagadahoc',
    SOMERSET = 'Somerset',
    WALDO = 'Waldo',
    WASHINGTON = 'Washington',
    YORK = 'York',
}

export enum MI_CountyType {
    ALCONA = 'Alcona',
    ALGER = 'Alger',
    ALLEGAN = 'Allegan',
    ALPENA = 'Alpena',
    ANTRIM = 'Antrim',
    ARENAC = 'Arenac',
    BARAGA = 'Baraga',
    BARRY = 'Barry',
    BAY = 'Bay',
    BENZIE = 'Benzie',
    BERRIEN = 'Berrien',
    BRANCH = 'Branch',
    CALHOUN = 'Calhoun',
    CASS = 'Cass',
    CHARLEVOIX = 'Charlevoix',
    CHEBOYGAN = 'Cheboygan',
    CHIPPEWA = 'Chippewa',
    CLARE = 'Clare',
    CLINTON = 'Clinton',
    CRAWFORD = 'Crawford',
    DELTA = 'Delta',
    DICKINSON = 'Dickinson',
    EATON = 'Eaton',
    EMMET = 'Emmet',
    GENESEE = 'Genesee',
    GLADWIN = 'Gladwin',
    GOGEBIC = 'Gogebic',
    GRAND_TRAVERSE = 'Grand Traverse',
    GRATIOT = 'Gratiot',
    HILLSDALE = 'Hillsdale',
    HOUGHTON = 'Houghton',
    HURON = 'Huron',
    INGHAM = 'Ingham',
    IONIA = 'Ionia',
    IOSCO = 'Iosco',
    IRON = 'Iron',
    ISABELLA = 'Isabella',
    JACKSON = 'Jackson',
    KALAMAZOO = 'Kalamazoo',
    KALKASKA = 'Kalkaska',
    KENT = 'Kent',
    KEWEENAW = 'Keweenaw',
    LAKE = 'Lake',
    LAPEER = 'Lapeer',
    LEELANAU = 'Leelanau',
    LENAWEE = 'Lenawee',
    LIVINGSTON = 'Livingston',
    LUCE = 'Luce',
    MACKINAC = 'Mackinac',
    MACOMB = 'Macomb',
    MANISTEE = 'Manistee',
    MARQUETTE = 'Marquette',
    MASON = 'Mason',
    MECOSTA = 'Mecosta',
    MENOMINEE = 'Menominee',
    MIDLAND = 'Midland',
    MISSAUKEE = 'Missaukee',
    MONROE = 'Monroe',
    MONTCALM = 'Montcalm',
    MONTMORENCY = 'Montmorency',
    MUSKEGON = 'Muskegon',
    NEWAYGO = 'Newaygo',
    OAKLAND = 'Oakland',
    OCEANA = 'Oceana',
    OGEMAW = 'Ogemaw',
    ONTONAGON = 'Ontonagon',
    OSCEOLA = 'Osceola',
    OSCODA = 'Oscoda',
    OTSEGO = 'Otsego',
    OTTAWA = 'Ottawa',
    PRESQUE_ISLE = 'Presque Isle',
    ROSCOMMON = 'Roscommon',
    SAGINAW = 'Saginaw',
    SAINT_CLAIR = 'Saint Clair',
    SAINT_JOSEPH = 'Saint Joseph',
    SANILAC = 'Sanilac',
    SCHOOLCRAFT = 'Schoolcraft',
    SHIAWASSEE = 'Shiawassee',
    TUSCOLA = 'Tuscola',
    VAN_BUREN = 'Van Buren',
    WASHTENAW = 'Washtenaw',
    WAYNE = 'Wayne',
    WEXFORD = 'Wexford',
}

export enum MN_CountyType {
    AITKIN = 'Aitkin',
    ANOKA = 'Anoka',
    BECKER = 'Becker',
    BELTRAMI = 'Beltrami',
    BENTON = 'Benton',
    BIG_STONE = 'Big Stone',
    BLUE_EARTH = 'Blue Earth',
    BROWN = 'Brown',
    CARLTON = 'Carlton',
    CARVER = 'Carver',
    CASS = 'Cass',
    CHIPPEWA = 'Chippewa',
    CHISAGO = 'Chisago',
    CLAY = 'Clay',
    CLEARWATER = 'Clearwater',
    COOK = 'Cook',
    COTTONWOOD = 'Cottonwood',
    CROW_WING = 'Crow Wing',
    DAKOTA = 'Dakota',
    DODGE = 'Dodge',
    DOUGLAS = 'Douglas',
    FARIBAULT = 'Faribault',
    FILLMORE = 'Fillmore',
    FREEBORN = 'Freeborn',
    GOODHUE = 'Goodhue',
    GRANT = 'Grant',
    HENNEPIN = 'Hennepin',
    HOUSTON = 'Houston',
    HUBBARD = 'Hubbard',
    ISANTI = 'Isanti',
    ITASCA = 'Itasca',
    JACKSON = 'Jackson',
    KANABEC = 'Kanabec',
    KANDIYOHI = 'Kandiyohi',
    KITTSON = 'Kittson',
    KOOCHICHING = 'Koochiching',
    LAC_QUI_PARLE = 'Lac Qui Parle',
    LAKE = 'Lake',
    LAKE_OF_THE_WOODS = 'Lake Of The Woods',
    LE_SUEUR = 'Le Sueur',
    LINCOLN = 'Lincoln',
    LYON = 'Lyon',
    MAHNOMEN = 'Mahnomen',
    MARSHALL = 'Marshall',
    MARTIN = 'Martin',
    MCLEOD = 'Mcleod',
    MEEKER = 'Meeker',
    MILLE_LACS = 'Mille Lacs',
    MORRISON = 'Morrison',
    MOWER = 'Mower',
    MURRAY = 'Murray',
    NICOLLET = 'Nicollet',
    NOBLES = 'Nobles',
    NORMAN = 'Norman',
    OLMSTED = 'Olmsted',
    OTTER_TAIL = 'Otter Tail',
    PENNINGTON = 'Pennington',
    PINE = 'Pine',
    PIPESTONE = 'Pipestone',
    POLK = 'Polk',
    POPE = 'Pope',
    RAMSEY = 'Ramsey',
    RED_LAKE = 'Red Lake',
    REDWOOD = 'Redwood',
    RENVILLE = 'Renville',
    RICE = 'Rice',
    ROCK = 'Rock',
    ROSEAU = 'Roseau',
    SAINT_LOUIS = 'Saint Louis',
    SCOTT = 'Scott',
    SHERBURNE = 'Sherburne',
    SIBLEY = 'Sibley',
    STEARNS = 'Stearns',
    STEELE = 'Steele',
    STEVENS = 'Stevens',
    SWIFT = 'Swift',
    TODD = 'Todd',
    TRAVERSE = 'Traverse',
    WABASHA = 'Wabasha',
    WADENA = 'Wadena',
    WASECA = 'Waseca',
    WASHINGTON = 'Washington',
    WATONWAN = 'Watonwan',
    WILKIN = 'Wilkin',
    WINONA = 'Winona',
    WRIGHT = 'Wright',
    YELLOW_MEDICINE = 'Yellow Medicine',
}

export enum MO_CountyType {
    ADAIR = 'Adair',
    ANDREW = 'Andrew',
    ATCHISON = 'Atchison',
    AUDRAIN = 'Audrain',
    BARRY = 'Barry',
    BARTON = 'Barton',
    BATES = 'Bates',
    BENTON = 'Benton',
    BOLLINGER = 'Bollinger',
    BOONE = 'Boone',
    BUCHANAN = 'Buchanan',
    BUTLER = 'Butler',
    CALDWELL = 'Caldwell',
    CALLAWAY = 'Callaway',
    CAMDEN = 'Camden',
    CAPE_GIRARDEAU = 'Cape Girardeau',
    CARROLL = 'Carroll',
    CARTER = 'Carter',
    CASS = 'Cass',
    CEDAR = 'Cedar',
    CHARITON = 'Chariton',
    CHRISTIAN = 'Christian',
    CLARK = 'Clark',
    CLAY = 'Clay',
    CLINTON = 'Clinton',
    COLE = 'Cole',
    COOPER = 'Cooper',
    CRAWFORD = 'Crawford',
    DADE = 'Dade',
    DALLAS = 'Dallas',
    DAVIESS = 'Daviess',
    DEKALB = 'Dekalb',
    DENT = 'Dent',
    DOUGLAS = 'Douglas',
    DUNKLIN = 'Dunklin',
    FRANKLIN = 'Franklin',
    GASCONADE = 'Gasconade',
    GENTRY = 'Gentry',
    GREENE = 'Greene',
    GRUNDY = 'Grundy',
    HARRISON = 'Harrison',
    HENRY = 'Henry',
    HICKORY = 'Hickory',
    HOLT = 'Holt',
    HOWARD = 'Howard',
    HOWELL = 'Howell',
    IRON = 'Iron',
    JACKSON = 'Jackson',
    JASPER = 'Jasper',
    JEFFERSON = 'Jefferson',
    JOHNSON = 'Johnson',
    KNOX = 'Knox',
    LACLEDE = 'Laclede',
    LAFAYETTE = 'Lafayette',
    LAWRENCE = 'Lawrence',
    LEWIS = 'Lewis',
    LINCOLN = 'Lincoln',
    LINN = 'Linn',
    LIVINGSTON = 'Livingston',
    MACON = 'Macon',
    MADISON = 'Madison',
    MARIES = 'Maries',
    MARION = 'Marion',
    MCDONALD = 'Mcdonald',
    MERCER = 'Mercer',
    MILLER = 'Miller',
    MISSISSIPPI = 'Mississippi',
    MONITEAU = 'Moniteau',
    MONROE = 'Monroe',
    MONTGOMERY = 'Montgomery',
    MORGAN = 'Morgan',
    NEW_MADRID = 'New Madrid',
    NEWTON = 'Newton',
    NODAWAY = 'Nodaway',
    OREGON = 'Oregon',
    OSAGE = 'Osage',
    OZARK = 'Ozark',
    PEMISCOT = 'Pemiscot',
    PERRY = 'Perry',
    PETTIS = 'Pettis',
    PHELPS = 'Phelps',
    PIKE = 'Pike',
    PLATTE = 'Platte',
    POLK = 'Polk',
    PULASKI = 'Pulaski',
    PUTNAM = 'Putnam',
    RALLS = 'Ralls',
    RANDOLPH = 'Randolph',
    RAY = 'Ray',
    REYNOLDS = 'Reynolds',
    RIPLEY = 'Ripley',
    SAINT_CHARLES = 'Saint Charles',
    SAINT_CLAIR = 'Saint Clair',
    SAINT_FRANCOIS = 'Saint Francois',
    SAINT_LOUIS = 'Saint Louis',
    SAINT_LOUIS_CITY = 'Saint Louis City',
    SAINTE_GENEVIEVE = 'Sainte Genevieve',
    SALINE = 'Saline',
    SCHUYLER = 'Schuyler',
    SCOTLAND = 'Scotland',
    SCOTT = 'Scott',
    SHANNON = 'Shannon',
    SHELBY = 'Shelby',
    STODDARD = 'Stoddard',
    STONE = 'Stone',
    SULLIVAN = 'Sullivan',
    TANEY = 'Taney',
    TEXAS = 'Texas',
    VERNON = 'Vernon',
    WARREN = 'Warren',
    WASHINGTON = 'Washington',
    WAYNE = 'Wayne',
    WEBSTER = 'Webster',
    WORTH = 'Worth',
    WRIGHT = 'Wright',
}

export enum MS_CountyType {
    ADAMS = 'Adams',
    ALCORN = 'Alcorn',
    AMITE = 'Amite',
    ATTALA = 'Attala',
    BENTON = 'Benton',
    BOLIVAR = 'Bolivar',
    CALHOUN = 'Calhoun',
    CARROLL = 'Carroll',
    CHICKASAW = 'Chickasaw',
    CHOCTAW = 'Choctaw',
    CLAIBORNE = 'Claiborne',
    CLARKE = 'Clarke',
    CLAY = 'Clay',
    COAHOMA = 'Coahoma',
    COPIAH = 'Copiah',
    COVINGTON = 'Covington',
    DESOTO = 'Desoto',
    FORREST = 'Forrest',
    FRANKLIN = 'Franklin',
    GEORGE = 'George',
    GREENE = 'Greene',
    GRENADA = 'Grenada',
    HANCOCK = 'Hancock',
    HARRISON = 'Harrison',
    HINDS = 'Hinds',
    HOLMES = 'Holmes',
    HUMPHREYS = 'Humphreys',
    ISSAQUENA = 'Issaquena',
    ITAWAMBA = 'Itawamba',
    JACKSON = 'Jackson',
    JASPER = 'Jasper',
    JEFFERSON = 'Jefferson',
    JEFFERSON_DAVIS = 'Jefferson Davis',
    JONES = 'Jones',
    KEMPER = 'Kemper',
    LAFAYETTE = 'Lafayette',
    LAMAR = 'Lamar',
    LAUDERDALE = 'Lauderdale',
    LAWRENCE = 'Lawrence',
    LEAKE = 'Leake',
    LEE = 'Lee',
    LEFLORE = 'Leflore',
    LINCOLN = 'Lincoln',
    LOWNDES = 'Lowndes',
    MADISON = 'Madison',
    MARION = 'Marion',
    MARSHALL = 'Marshall',
    MONROE = 'Monroe',
    MONTGOMERY = 'Montgomery',
    NESHOBA = 'Neshoba',
    NEWTON = 'Newton',
    NOXUBEE = 'Noxubee',
    OKTIBBEHA = 'Oktibbeha',
    PANOLA = 'Panola',
    PEARL_RIVER = 'Pearl River',
    PERRY = 'Perry',
    PIKE = 'Pike',
    PONTOTOC = 'Pontotoc',
    PRENTISS = 'Prentiss',
    QUITMAN = 'Quitman',
    RANKIN = 'Rankin',
    SCOTT = 'Scott',
    SHARKEY = 'Sharkey',
    SIMPSON = 'Simpson',
    SMITH = 'Smith',
    STONE = 'Stone',
    SUNFLOWER = 'Sunflower',
    TALLAHATCHIE = 'Tallahatchie',
    TATE = 'Tate',
    TIPPAH = 'Tippah',
    TISHOMINGO = 'Tishomingo',
    TUNICA = 'Tunica',
    UNION = 'Union',
    WALTHALL = 'Walthall',
    WARREN = 'Warren',
    WASHINGTON = 'Washington',
    WAYNE = 'Wayne',
    WEBSTER = 'Webster',
    WILKINSON = 'Wilkinson',
    WINSTON = 'Winston',
    YALOBUSHA = 'Yalobusha',
    YAZOO = 'Yazoo',
}

export enum MT_CountyType {
    BEAVERHEAD = 'Beaverhead',
    BIG_HORN = 'Big Horn',
    BLAINE = 'Blaine',
    BROADWATER = 'Broadwater',
    CARBON = 'Carbon',
    CARTER = 'Carter',
    CASCADE = 'Cascade',
    CHOUTEAU = 'Chouteau',
    CUSTER = 'Custer',
    DANIELS = 'Daniels',
    DAWSON = 'Dawson',
    DEER_LODGE = 'Deer Lodge',
    FALLON = 'Fallon',
    FERGUS = 'Fergus',
    FLATHEAD = 'Flathead',
    GALLATIN = 'Gallatin',
    GARFIELD = 'Garfield',
    GLACIER = 'Glacier',
    GOLDEN_VALLEY = 'Golden Valley',
    GRANITE = 'Granite',
    HILL = 'Hill',
    JEFFERSON = 'Jefferson',
    JUDITH_BASIN = 'Judith Basin',
    LAKE = 'Lake',
    LEWIS_AND_CLARK = 'Lewis And Clark',
    LIBERTY = 'Liberty',
    LINCOLN = 'Lincoln',
    MADISON = 'Madison',
    MCCONE = 'Mccone',
    MEAGHER = 'Meagher',
    MINERAL = 'Mineral',
    MISSOULA = 'Missoula',
    MUSSELSHELL = 'Musselshell',
    PARK = 'Park',
    PETROLEUM = 'Petroleum',
    PHILLIPS = 'Phillips',
    PONDERA = 'Pondera',
    POWDER_RIVER = 'Powder River',
    POWELL = 'Powell',
    PRAIRIE = 'Prairie',
    RAVALLI = 'Ravalli',
    RICHLAND = 'Richland',
    ROOSEVELT = 'Roosevelt',
    ROSEBUD = 'Rosebud',
    SANDERS = 'Sanders',
    SHERIDAN = 'Sheridan',
    SILVER_BOW = 'Silver Bow',
    STILLWATER = 'Stillwater',
    SWEET_GRASS = 'Sweet Grass',
    TETON = 'Teton',
    TOOLE = 'Toole',
    TREASURE = 'Treasure',
    VALLEY = 'Valley',
    WHEATLAND = 'Wheatland',
    WIBAUX = 'Wibaux',
    YELLOWSTONE = 'Yellowstone',
}

export enum NC_CountyType {
    ALAMANCE = 'Alamance',
    ALEXANDER = 'Alexander',
    ALLEGHANY = 'Alleghany',
    ANSON = 'Anson',
    ASHE = 'Ashe',
    AVERY = 'Avery',
    BEAUFORT = 'Beaufort',
    BERTIE = 'Bertie',
    BLADEN = 'Bladen',
    BRUNSWICK = 'Brunswick',
    BUNCOMBE = 'Buncombe',
    BURKE = 'Burke',
    CABARRUS = 'Cabarrus',
    CALDWELL = 'Caldwell',
    CAMDEN = 'Camden',
    CARTERET = 'Carteret',
    CASWELL = 'Caswell',
    CATAWBA = 'Catawba',
    CHATHAM = 'Chatham',
    CHEROKEE = 'Cherokee',
    CHOWAN = 'Chowan',
    CLAY = 'Clay',
    CLEVELAND = 'Cleveland',
    COLUMBUS = 'Columbus',
    CRAVEN = 'Craven',
    CUMBERLAND = 'Cumberland',
    CURRITUCK = 'Currituck',
    DARE = 'Dare',
    DAVIDSON = 'Davidson',
    DAVIE = 'Davie',
    DUPLIN = 'Duplin',
    DURHAM = 'Durham',
    EDGECOMBE = 'Edgecombe',
    FORSYTH = 'Forsyth',
    FRANKLIN = 'Franklin',
    GASTON = 'Gaston',
    GATES = 'Gates',
    GRAHAM = 'Graham',
    GRANVILLE = 'Granville',
    GREENE = 'Greene',
    GUILFORD = 'Guilford',
    HALIFAX = 'Halifax',
    HARNETT = 'Harnett',
    HAYWOOD = 'Haywood',
    HENDERSON = 'Henderson',
    HERTFORD = 'Hertford',
    HOKE = 'Hoke',
    HYDE = 'Hyde',
    IREDELL = 'Iredell',
    JACKSON = 'Jackson',
    JOHNSTON = 'Johnston',
    JONES = 'Jones',
    LEE = 'Lee',
    LENOIR = 'Lenoir',
    LINCOLN = 'Lincoln',
    MACON = 'Macon',
    MADISON = 'Madison',
    MARTIN = 'Martin',
    MCDOWELL = 'Mcdowell',
    MECKLENBURG = 'Mecklenburg',
    MITCHELL = 'Mitchell',
    MONTGOMERY = 'Montgomery',
    MOORE = 'Moore',
    NASH = 'Nash',
    NEW_HANOVER = 'New Hanover',
    NORTHAMPTON = 'Northampton',
    ONSLOW = 'Onslow',
    ORANGE = 'Orange',
    PAMLICO = 'Pamlico',
    PASQUOTANK = 'Pasquotank',
    PENDER = 'Pender',
    PERQUIMANS = 'Perquimans',
    PERSON = 'Person',
    PITT = 'Pitt',
    POLK = 'Polk',
    RANDOLPH = 'Randolph',
    RICHMOND = 'Richmond',
    ROBESON = 'Robeson',
    ROCKINGHAM = 'Rockingham',
    ROWAN = 'Rowan',
    RUTHERFORD = 'Rutherford',
    SAMPSON = 'Sampson',
    SCOTLAND = 'Scotland',
    STANLY = 'Stanly',
    STOKES = 'Stokes',
    SURRY = 'Surry',
    SWAIN = 'Swain',
    TRANSYLVANIA = 'Transylvania',
    TYRRELL = 'Tyrrell',
    UNION = 'Union',
    VANCE = 'Vance',
    WAKE = 'Wake',
    WARREN = 'Warren',
    WASHINGTON = 'Washington',
    WATAUGA = 'Watauga',
    WAYNE = 'Wayne',
    WILKES = 'Wilkes',
    WILSON = 'Wilson',
    YADKIN = 'Yadkin',
    YANCEY = 'Yancey',
}

export enum ND_CountyType {
    ADAMS = 'Adams',
    BARNES = 'Barnes',
    BENSON = 'Benson',
    BILLINGS = 'Billings',
    BOTTINEAU = 'Bottineau',
    BOWMAN = 'Bowman',
    BURKE = 'Burke',
    BURLEIGH = 'Burleigh',
    CASS = 'Cass',
    CAVALIER = 'Cavalier',
    DICKEY = 'Dickey',
    DIVIDE = 'Divide',
    DUNN = 'Dunn',
    EDDY = 'Eddy',
    EMMONS = 'Emmons',
    FOSTER = 'Foster',
    GOLDEN_VALLEY = 'Golden Valley',
    GRAND_FORKS = 'Grand Forks',
    GRANT = 'Grant',
    GRIGGS = 'Griggs',
    HETTINGER = 'Hettinger',
    KIDDER = 'Kidder',
    LAMOURE = 'Lamoure',
    LOGAN = 'Logan',
    MCHENRY = 'Mchenry',
    MCINTOSH = 'Mcintosh',
    MCKENZIE = 'Mckenzie',
    MCLEAN = 'Mclean',
    MERCER = 'Mercer',
    MORTON = 'Morton',
    MOUNTRAIL = 'Mountrail',
    NELSON = 'Nelson',
    OLIVER = 'Oliver',
    PEMBINA = 'Pembina',
    PIERCE = 'Pierce',
    RAMSEY = 'Ramsey',
    RANSOM = 'Ransom',
    RENVILLE = 'Renville',
    RICHLAND = 'Richland',
    ROLETTE = 'Rolette',
    SARGENT = 'Sargent',
    SHERIDAN = 'Sheridan',
    SIOUX = 'Sioux',
    SLOPE = 'Slope',
    STARK = 'Stark',
    STEELE = 'Steele',
    STUTSMAN = 'Stutsman',
    TOWNER = 'Towner',
    TRAILL = 'Traill',
    WALSH = 'Walsh',
    WARD = 'Ward',
    WELLS = 'Wells',
    WILLIAMS = 'Williams',
}

export enum NE_CountyType {
    ADAMS = 'Adams',
    ANTELOPE = 'Antelope',
    ARTHUR = 'Arthur',
    BANNER = 'Banner',
    BLAINE = 'Blaine',
    BOONE = 'Boone',
    BOX_BUTTE = 'Box Butte',
    BOYD = 'Boyd',
    BROWN = 'Brown',
    BUFFALO = 'Buffalo',
    BURT = 'Burt',
    BUTLER = 'Butler',
    CASS = 'Cass',
    CEDAR = 'Cedar',
    CHASE = 'Chase',
    CHERRY = 'Cherry',
    CHEYENNE = 'Cheyenne',
    CLAY = 'Clay',
    COLFAX = 'Colfax',
    CUMING = 'Cuming',
    CUSTER = 'Custer',
    DAKOTA = 'Dakota',
    DAWES = 'Dawes',
    DAWSON = 'Dawson',
    DEUEL = 'Deuel',
    DIXON = 'Dixon',
    DODGE = 'Dodge',
    DOUGLAS = 'Douglas',
    DUNDY = 'Dundy',
    FILLMORE = 'Fillmore',
    FRANKLIN = 'Franklin',
    FRONTIER = 'Frontier',
    FURNAS = 'Furnas',
    GAGE = 'Gage',
    GARDEN = 'Garden',
    GARFIELD = 'Garfield',
    GOSPER = 'Gosper',
    GRANT = 'Grant',
    GREELEY = 'Greeley',
    HALL = 'Hall',
    HAMILTON = 'Hamilton',
    HARLAN = 'Harlan',
    HAYES = 'Hayes',
    HITCHCOCK = 'Hitchcock',
    HOLT = 'Holt',
    HOOKER = 'Hooker',
    HOWARD = 'Howard',
    JEFFERSON = 'Jefferson',
    JOHNSON = 'Johnson',
    KEARNEY = 'Kearney',
    KEITH = 'Keith',
    KEYA_PAHA = 'Keya Paha',
    KIMBALL = 'Kimball',
    KNOX = 'Knox',
    LANCASTER = 'Lancaster',
    LINCOLN = 'Lincoln',
    LOGAN = 'Logan',
    LOUP = 'Loup',
    MADISON = 'Madison',
    MCPHERSON = 'Mcpherson',
    MERRICK = 'Merrick',
    MORRILL = 'Morrill',
    NANCE = 'Nance',
    NEMAHA = 'Nemaha',
    NUCKOLLS = 'Nuckolls',
    OTOE = 'Otoe',
    PAWNEE = 'Pawnee',
    PERKINS = 'Perkins',
    PHELPS = 'Phelps',
    PIERCE = 'Pierce',
    PLATTE = 'Platte',
    POLK = 'Polk',
    RED_WILLOW = 'Red Willow',
    RICHARDSON = 'Richardson',
    ROCK = 'Rock',
    SALINE = 'Saline',
    SARPY = 'Sarpy',
    SAUNDERS = 'Saunders',
    SCOTTS_BLUFF = 'Scotts Bluff',
    SEWARD = 'Seward',
    SHERIDAN = 'Sheridan',
    SHERMAN = 'Sherman',
    SIOUX = 'Sioux',
    STANTON = 'Stanton',
    THAYER = 'Thayer',
    THOMAS = 'Thomas',
    THURSTON = 'Thurston',
    VALLEY = 'Valley',
    WASHINGTON = 'Washington',
    WAYNE = 'Wayne',
    WEBSTER = 'Webster',
    WHEELER = 'Wheeler',
    YORK = 'York',
}

export enum NH_CountyType {
    BELKNAP = 'Belknap',
    CARROLL = 'Carroll',
    CHESHIRE = 'Cheshire',
    COOS = 'Coos',
    GRAFTON = 'Grafton',
    HILLSBOROUGH = 'Hillsborough',
    MERRIMACK = 'Merrimack',
    ROCKINGHAM = 'Rockingham',
    STRAFFORD = 'Strafford',
    SULLIVAN = 'Sullivan',
}

export enum NJ_CountyType {
    ATLANTIC = 'Atlantic',
    BERGEN = 'Bergen',
    BURLINGTON = 'Burlington',
    CAMDEN = 'Camden',
    CAPE_MAY = 'Cape May',
    CUMBERLAND = 'Cumberland',
    ESSEX = 'Essex',
    GLOUCESTER = 'Gloucester',
    HUDSON = 'Hudson',
    HUNTERDON = 'Hunterdon',
    MERCER = 'Mercer',
    MIDDLESEX = 'Middlesex',
    MONMOUTH = 'Monmouth',
    MORRIS = 'Morris',
    OCEAN = 'Ocean',
    PASSAIC = 'Passaic',
    SALEM = 'Salem',
    SOMERSET = 'Somerset',
    SUSSEX = 'Sussex',
    UNION = 'Union',
    WARREN = 'Warren',
}

export enum NM_CountyType {
    BERNALILLO = 'Bernalillo',
    CATRON = 'Catron',
    CHAVES = 'Chaves',
    CIBOLA = 'Cibola',
    COLFAX = 'Colfax',
    CURRY = 'Curry',
    DE_BACA = 'De Baca',
    DONA_ANA = 'Dona Ana',
    EDDY = 'Eddy',
    GRANT = 'Grant',
    GUADALUPE = 'Guadalupe',
    HARDING = 'Harding',
    HIDALGO = 'Hidalgo',
    LEA = 'Lea',
    LINCOLN = 'Lincoln',
    LOS_ALAMOS = 'Los Alamos',
    LUNA = 'Luna',
    MCKINLEY = 'Mckinley',
    MORA = 'Mora',
    OTERO = 'Otero',
    QUAY = 'Quay',
    RIO_ARRIBA = 'Rio Arriba',
    ROOSEVELT = 'Roosevelt',
    SAN_JUAN = 'San Juan',
    SAN_MIGUEL = 'San Miguel',
    SANDOVAL = 'Sandoval',
    SANTA_FE = 'Santa Fe',
    SIERRA = 'Sierra',
    SOCORRO = 'Socorro',
    TAOS = 'Taos',
    TORRANCE = 'Torrance',
    UNION = 'Union',
    VALENCIA = 'Valencia',
}

export enum NV_CountyType {
    CARSON_CITY = 'Carson City',
    CHURCHILL = 'Churchill',
    CLARK = 'Clark',
    DOUGLAS = 'Douglas',
    ELKO = 'Elko',
    ESMERALDA = 'Esmeralda',
    EUREKA = 'Eureka',
    HUMBOLDT = 'Humboldt',
    LANDER = 'Lander',
    LINCOLN = 'Lincoln',
    LYON = 'Lyon',
    MINERAL = 'Mineral',
    NYE = 'Nye',
    PERSHING = 'Pershing',
    STOREY = 'Storey',
    WASHOE = 'Washoe',
    WHITE_PINE = 'White Pine',
}

export enum NY_CountyType {
    ALBANY = 'Albany',
    ALLEGANY = 'Allegany',
    BRONX = 'Bronx',
    BROOME = 'Broome',
    CATTARAUGUS = 'Cattaraugus',
    CAYUGA = 'Cayuga',
    CHAUTAUQUA = 'Chautauqua',
    CHEMUNG = 'Chemung',
    CHENANGO = 'Chenango',
    CLINTON = 'Clinton',
    COLUMBIA = 'Columbia',
    CORTLAND = 'Cortland',
    DELAWARE = 'Delaware',
    DUTCHESS = 'Dutchess',
    ERIE = 'Erie',
    ESSEX = 'Essex',
    FRANKLIN = 'Franklin',
    FULTON = 'Fulton',
    GENESEE = 'Genesee',
    GREENE = 'Greene',
    HAMILTON = 'Hamilton',
    HERKIMER = 'Herkimer',
    JEFFERSON = 'Jefferson',
    KINGS = 'Kings',
    LEWIS = 'Lewis',
    LIVINGSTON = 'Livingston',
    MADISON = 'Madison',
    MONROE = 'Monroe',
    MONTGOMERY = 'Montgomery',
    NASSAU = 'Nassau',
    NEW_YORK = 'New York',
    NIAGARA = 'Niagara',
    ONEIDA = 'Oneida',
    ONONDAGA = 'Onondaga',
    ONTARIO = 'Ontario',
    ORANGE = 'Orange',
    ORLEANS = 'Orleans',
    OSWEGO = 'Oswego',
    OTSEGO = 'Otsego',
    PUTNAM = 'Putnam',
    QUEENS = 'Queens',
    RENSSELAER = 'Rensselaer',
    RICHMOND = 'Richmond',
    ROCKLAND = 'Rockland',
    SAINT_LAWRENCE = 'Saint Lawrence',
    SARATOGA = 'Saratoga',
    SCHENECTADY = 'Schenectady',
    SCHOHARIE = 'Schoharie',
    SCHUYLER = 'Schuyler',
    SENECA = 'Seneca',
    STEUBEN = 'Steuben',
    SUFFOLK = 'Suffolk',
    SULLIVAN = 'Sullivan',
    TIOGA = 'Tioga',
    TOMPKINS = 'Tompkins',
    ULSTER = 'Ulster',
    WARREN = 'Warren',
    WASHINGTON = 'Washington',
    WAYNE = 'Wayne',
    WESTCHESTER = 'Westchester',
    WYOMING = 'Wyoming',
    YATES = 'Yates',
}

export enum OH_CountyType {
    ADAMS = 'Adams',
    ALLEN = 'Allen',
    ASHLAND = 'Ashland',
    ASHTABULA = 'Ashtabula',
    ATHENS = 'Athens',
    AUGLAIZE = 'Auglaize',
    BELMONT = 'Belmont',
    BROWN = 'Brown',
    BUTLER = 'Butler',
    CARROLL = 'Carroll',
    CHAMPAIGN = 'Champaign',
    CLARK = 'Clark',
    CLERMONT = 'Clermont',
    CLINTON = 'Clinton',
    COLUMBIANA = 'Columbiana',
    COSHOCTON = 'Coshocton',
    CRAWFORD = 'Crawford',
    CUYAHOGA = 'Cuyahoga',
    DARKE = 'Darke',
    DEFIANCE = 'Defiance',
    DELAWARE = 'Delaware',
    ERIE = 'Erie',
    FAIRFIELD = 'Fairfield',
    FAYETTE = 'Fayette',
    FRANKLIN = 'Franklin',
    FULTON = 'Fulton',
    GALLIA = 'Gallia',
    GEAUGA = 'Geauga',
    GREENE = 'Greene',
    GUERNSEY = 'Guernsey',
    HAMILTON = 'Hamilton',
    HANCOCK = 'Hancock',
    HARDIN = 'Hardin',
    HARRISON = 'Harrison',
    HENRY = 'Henry',
    HIGHLAND = 'Highland',
    HOCKING = 'Hocking',
    HOLMES = 'Holmes',
    HURON = 'Huron',
    JACKSON = 'Jackson',
    JEFFERSON = 'Jefferson',
    KNOX = 'Knox',
    LAKE = 'Lake',
    LAWRENCE = 'Lawrence',
    LICKING = 'Licking',
    LOGAN = 'Logan',
    LORAIN = 'Lorain',
    LUCAS = 'Lucas',
    MADISON = 'Madison',
    MAHONING = 'Mahoning',
    MARION = 'Marion',
    MEDINA = 'Medina',
    MEIGS = 'Meigs',
    MERCER = 'Mercer',
    MIAMI = 'Miami',
    MONROE = 'Monroe',
    MONTGOMERY = 'Montgomery',
    MORGAN = 'Morgan',
    MORROW = 'Morrow',
    MUSKINGUM = 'Muskingum',
    NOBLE = 'Noble',
    OTTAWA = 'Ottawa',
    PAULDING = 'Paulding',
    PERRY = 'Perry',
    PICKAWAY = 'Pickaway',
    PIKE = 'Pike',
    PORTAGE = 'Portage',
    PREBLE = 'Preble',
    PUTNAM = 'Putnam',
    RICHLAND = 'Richland',
    ROSS = 'Ross',
    SANDUSKY = 'Sandusky',
    SCIOTO = 'Scioto',
    SENECA = 'Seneca',
    SHELBY = 'Shelby',
    STARK = 'Stark',
    SUMMIT = 'Summit',
    TRUMBULL = 'Trumbull',
    TUSCARAWAS = 'Tuscarawas',
    UNION = 'Union',
    VAN_WERT = 'Van Wert',
    VINTON = 'Vinton',
    WARREN = 'Warren',
    WASHINGTON = 'Washington',
    WAYNE = 'Wayne',
    WILLIAMS = 'Williams',
    WOOD = 'Wood',
    WYANDOT = 'Wyandot',
}

export enum OK_CountyType {
    ADAIR = 'Adair',
    ALFALFA = 'Alfalfa',
    ATOKA = 'Atoka',
    BEAVER = 'Beaver',
    BECKHAM = 'Beckham',
    BLAINE = 'Blaine',
    BRYAN = 'Bryan',
    CADDO = 'Caddo',
    CANADIAN = 'Canadian',
    CARTER = 'Carter',
    CHEROKEE = 'Cherokee',
    CHOCTAW = 'Choctaw',
    CIMARRON = 'Cimarron',
    CLEVELAND = 'Cleveland',
    COAL = 'Coal',
    COMANCHE = 'Comanche',
    COTTON = 'Cotton',
    CRAIG = 'Craig',
    CREEK = 'Creek',
    CUSTER = 'Custer',
    DELAWARE = 'Delaware',
    DEWEY = 'Dewey',
    ELLIS = 'Ellis',
    GARFIELD = 'Garfield',
    GARVIN = 'Garvin',
    GRADY = 'Grady',
    GRANT = 'Grant',
    GREER = 'Greer',
    HARMON = 'Harmon',
    HARPER = 'Harper',
    HASKELL = 'Haskell',
    HUGHES = 'Hughes',
    JACKSON = 'Jackson',
    JEFFERSON = 'Jefferson',
    JOHNSTON = 'Johnston',
    KAY = 'Kay',
    KINGFISHER = 'Kingfisher',
    KIOWA = 'Kiowa',
    LATIMER = 'Latimer',
    LE_FLORE = 'Le Flore',
    LINCOLN = 'Lincoln',
    LOGAN = 'Logan',
    LOVE = 'Love',
    MAJOR = 'Major',
    MARSHALL = 'Marshall',
    MAYES = 'Mayes',
    MCCLAIN = 'Mcclain',
    MCCURTAIN = 'Mccurtain',
    MCINTOSH = 'Mcintosh',
    MURRAY = 'Murray',
    MUSKOGEE = 'Muskogee',
    NOBLE = 'Noble',
    NOWATA = 'Nowata',
    OKFUSKEE = 'Okfuskee',
    OKLAHOMA = 'Oklahoma',
    OKMULGEE = 'Okmulgee',
    OSAGE = 'Osage',
    OTTAWA = 'Ottawa',
    PAWNEE = 'Pawnee',
    PAYNE = 'Payne',
    PITTSBURG = 'Pittsburg',
    PONTOTOC = 'Pontotoc',
    POTTAWATOMIE = 'Pottawatomie',
    PUSHMATAHA = 'Pushmataha',
    ROGER_MILLS = 'Roger Mills',
    ROGERS = 'Rogers',
    SEMINOLE = 'Seminole',
    SEQUOYAH = 'Sequoyah',
    STEPHENS = 'Stephens',
    TEXAS = 'Texas',
    TILLMAN = 'Tillman',
    TULSA = 'Tulsa',
    WAGONER = 'Wagoner',
    WASHINGTON = 'Washington',
    WASHITA = 'Washita',
    WOODS = 'Woods',
    WOODWARD = 'Woodward',
}

export enum OR_CountyType {
    BAKER = 'Baker',
    BENTON = 'Benton',
    CLACKAMAS = 'Clackamas',
    CLATSOP = 'Clatsop',
    COLUMBIA = 'Columbia',
    COOS = 'Coos',
    CROOK = 'Crook',
    CURRY = 'Curry',
    DESCHUTES = 'Deschutes',
    DOUGLAS = 'Douglas',
    GILLIAM = 'Gilliam',
    GRANT = 'Grant',
    HARNEY = 'Harney',
    HOOD_RIVER = 'Hood River',
    JACKSON = 'Jackson',
    JEFFERSON = 'Jefferson',
    JOSEPHINE = 'Josephine',
    KLAMATH = 'Klamath',
    LAKE = 'Lake',
    LANE = 'Lane',
    LINCOLN = 'Lincoln',
    LINN = 'Linn',
    MALHEUR = 'Malheur',
    MARION = 'Marion',
    MORROW = 'Morrow',
    MULTNOMAH = 'Multnomah',
    POLK = 'Polk',
    SHERMAN = 'Sherman',
    TILLAMOOK = 'Tillamook',
    UMATILLA = 'Umatilla',
    UNION = 'Union',
    WALLOWA = 'Wallowa',
    WASCO = 'Wasco',
    WASHINGTON = 'Washington',
    WHEELER = 'Wheeler',
    YAMHILL = 'Yamhill',
}

export enum PA_CountyType {
    ADAMS = 'Adams',
    ALLEGHENY = 'Allegheny',
    ARMSTRONG = 'Armstrong',
    BEAVER = 'Beaver',
    BEDFORD = 'Bedford',
    BERKS = 'Berks',
    BLAIR = 'Blair',
    BRADFORD = 'Bradford',
    BUCKS = 'Bucks',
    BUTLER = 'Butler',
    CAMBRIA = 'Cambria',
    CAMERON = 'Cameron',
    CARBON = 'Carbon',
    CENTRE = 'Centre',
    CHESTER = 'Chester',
    CLARION = 'Clarion',
    CLEARFIELD = 'Clearfield',
    CLINTON = 'Clinton',
    COLUMBIA = 'Columbia',
    CRAWFORD = 'Crawford',
    CUMBERLAND = 'Cumberland',
    DAUPHIN = 'Dauphin',
    DELAWARE = 'Delaware',
    ELK = 'Elk',
    ERIE = 'Erie',
    FAYETTE = 'Fayette',
    FOREST = 'Forest',
    FRANKLIN = 'Franklin',
    FULTON = 'Fulton',
    GREENE = 'Greene',
    HUNTINGDON = 'Huntingdon',
    INDIANA = 'Indiana',
    JEFFERSON = 'Jefferson',
    JUNIATA = 'Juniata',
    LACKAWANNA = 'Lackawanna',
    LANCASTER = 'Lancaster',
    LAWRENCE = 'Lawrence',
    LEBANON = 'Lebanon',
    LEHIGH = 'Lehigh',
    LUZERNE = 'Luzerne',
    LYCOMING = 'Lycoming',
    MCKEAN = 'Mckean',
    MERCER = 'Mercer',
    MIFFLIN = 'Mifflin',
    MONROE = 'Monroe',
    MONTGOMERY = 'Montgomery',
    MONTOUR = 'Montour',
    NORTHAMPTON = 'Northampton',
    NORTHUMBERLAND = 'Northumberland',
    PERRY = 'Perry',
    PHILADELPHIA = 'Philadelphia',
    PIKE = 'Pike',
    POTTER = 'Potter',
    SCHUYLKILL = 'Schuylkill',
    SNYDER = 'Snyder',
    SOMERSET = 'Somerset',
    SULLIVAN = 'Sullivan',
    SUSQUEHANNA = 'Susquehanna',
    TIOGA = 'Tioga',
    UNION = 'Union',
    VENANGO = 'Venango',
    WARREN = 'Warren',
    WASHINGTON = 'Washington',
    WAYNE = 'Wayne',
    WESTMORELAND = 'Westmoreland',
    WYOMING = 'Wyoming',
    YORK = 'York',
}

export enum RI_CountyType {
    BRISTOL = 'Bristol',
    KENT = 'Kent',
    NEWPORT = 'Newport',
    PROVIDENCE = 'Providence',
    WASHINGTON = 'Washington',
}

export enum SC_CountyType {
    ABBEVILLE = 'Abbeville',
    AIKEN = 'Aiken',
    ALLENDALE = 'Allendale',
    ANDERSON = 'Anderson',
    BAMBERG = 'Bamberg',
    BARNWELL = 'Barnwell',
    BEAUFORT = 'Beaufort',
    BERKELEY = 'Berkeley',
    CALHOUN = 'Calhoun',
    CHARLSTON = 'Charleston',
    CHEROKEE = 'Cherokee',
    CHESTER = 'Chester',
    CHESTERFIELD = 'Chesterfield',
    CLARENDON = 'Clarendon',
    COLLETON = 'Colleton',
    DARLINGTON = 'Darlington',
    DILLON = 'Dillon',
    DORCHESTER = 'Dorchester',
    EDGEFIELD = 'Edgefield',
    FAIRFIELD = 'Fairfield',
    FLORENCE = 'Florence',
    GEORGETOWN = 'Georgetown',
    GREENVILLE = 'Greenville',
    GREENWOOD = 'Greenwood',
    HAMPTON = 'Hampton',
    HORRY = 'Horry',
    JASPER = 'Jasper',
    KERSHAW = 'Kershaw',
    LANCASTER = 'Lancaster',
    LAURENS = 'Laurens',
    LEE = 'Lee',
    LEXINGTON = 'Lexington',
    MARION = 'Marion',
    MARLBORO = 'Marlboro',
    MCCORMICK = 'Mccormick',
    NEWBERRY = 'Newberry',
    OCONEE = 'Oconee',
    ORANGEBURG = 'Orangeburg',
    PICKENS = 'Pickens',
    RICHLAND = 'Richland',
    SALUDA = 'Saluda',
    SPARTANBURG = 'Spartanburg',
    SUMTER = 'Sumter',
    UNION = 'Union',
    WILLIAMSBURG = 'Williamsburg',
    YORK = 'York',
}

export enum SD_CountyType {
    AURORA = 'Aurora',
    BEADLE = 'Beadle',
    BENNETT = 'Bennett',
    BON_HOMME = 'Bon Homme',
    BROOKINGS = 'Brookings',
    BROWN = 'Brown',
    BRULE = 'Brule',
    BUFFALO = 'Buffalo',
    BUTTE = 'Butte',
    CAMPBELL = 'Campbell',
    CHARLES_MIX = 'Charles Mix',
    CLARK = 'Clark',
    CLAY = 'Clay',
    CODINGTON = 'Codington',
    CORSON = 'Corson',
    CUSTER = 'Custer',
    DAVISON = 'Davison',
    DAY = 'Day',
    DEUEL = 'Deuel',
    DEWEY = 'Dewey',
    DOUGLAS = 'Douglas',
    EDMUNDS = 'Edmunds',
    FALL_RIVER = 'Fall River',
    FAULK = 'Faulk',
    GRANT = 'Grant',
    GREGORY = 'Gregory',
    HAAKON = 'Haakon',
    HAMLIN = 'Hamlin',
    HAND = 'Hand',
    HANSON = 'Hanson',
    HARDING = 'Harding',
    HUGHES = 'Hughes',
    HUTCHINSON = 'Hutchinson',
    HYDE = 'Hyde',
    JACKSON = 'Jackson',
    JERAULD = 'Jerauld',
    JONES = 'Jones',
    KINGSBURY = 'Kingsbury',
    LAKE = 'Lake',
    LAWRENCE = 'Lawrence',
    LINCOLN = 'Lincoln',
    LYMAN = 'Lyman',
    MARSHALL = 'Marshall',
    MCCOOK = 'Mccook',
    MCPHERSON = 'Mcpherson',
    MEADE = 'Meade',
    MELLETTE = 'Mellette',
    MINER = 'Miner',
    MINNEHAHA = 'Minnehaha',
    MOODY = 'Moody',
    OGLALA_LAKOTA = 'Oglala Lakota',
    PENNINGTON = 'Pennington',
    PERKINS = 'Perkins',
    POTTER = 'Potter',
    ROBERTS = 'Roberts',
    SANBORN = 'Sanborn',
    SPINK = 'Spink',
    STANLEY = 'Stanley',
    SULLY = 'Sully',
    TODD = 'Todd',
    TRIPP = 'Tripp',
    TURNER = 'Turner',
    UNION = 'Union',
    WALWORTH = 'Walworth',
    YANKTON = 'Yankton',
    ZIEBACH = 'Ziebach',
}

export enum TN_CountyType {
    ANDERSON = 'Anderson',
    BEDFORD = 'Bedford',
    BENTON = 'Benton',
    BLEDSOE = 'Bledsoe',
    BLOUNT = 'Blount',
    BRADLEY = 'Bradley',
    CAMPBELL = 'Campbell',
    CANNON = 'Cannon',
    CARROLL = 'Carroll',
    CARTER = 'Carter',
    CHEATHAM = 'Cheatham',
    CHESTER = 'Chester',
    CLAIBORNE = 'Claiborne',
    CLAY = 'Clay',
    COCKE = 'Cocke',
    COFFEE = 'Coffee',
    CROCKETT = 'Crockett',
    CUMBERLAND = 'Cumberland',
    DAVIDSON = 'Davidson',
    DECATUR = 'Decatur',
    DEKALB = 'Dekalb',
    DICKSON = 'Dickson',
    DYER = 'Dyer',
    FAYETTE = 'Fayette',
    FENTRESS = 'Fentress',
    FRANKLIN = 'Franklin',
    GIBSON = 'Gibson',
    GILES = 'Giles',
    GRAINGER = 'Grainger',
    GREENE = 'Greene',
    GRUNDY = 'Grundy',
    HAMBLEN = 'Hamblen',
    HAMILTON = 'Hamilton',
    HANCOCK = 'Hancock',
    HARDEMAN = 'Hardeman',
    HARDIN = 'Hardin',
    HAWKINS = 'Hawkins',
    HAYWOOD = 'Haywood',
    HENDERSON = 'Henderson',
    HENRY = 'Henry',
    HICKMAN = 'Hickman',
    HOUSTON = 'Houston',
    HUMPHREYS = 'Humphreys',
    JACKSON = 'Jackson',
    JEFFERSON = 'Jefferson',
    JOHNSON = 'Johnson',
    KNOX = 'Knox',
    LAKE = 'Lake',
    LAUDERDALE = 'Lauderdale',
    LAWRENCE = 'Lawrence',
    LEWIS = 'Lewis',
    LINCOLN = 'Lincoln',
    LOUDON = 'Loudon',
    MACON = 'Macon',
    MADISON = 'Madison',
    MARION = 'Marion',
    MARSHALL = 'Marshall',
    MAURY = 'Maury',
    MCMINN = 'Mcminn',
    MCNAIRY = 'Mcnairy',
    MEIGS = 'Meigs',
    MONROE = 'Monroe',
    MONTGOMERY = 'Montgomery',
    MOORE = 'Moore',
    MORGAN = 'Morgan',
    OBION = 'Obion',
    OVERTON = 'Overton',
    PERRY = 'Perry',
    PICKETT = 'Pickett',
    POLK = 'Polk',
    PUTNAM = 'Putnam',
    RHEA = 'Rhea',
    ROANE = 'Roane',
    ROBERTSON = 'Robertson',
    RUTHERFORD = 'Rutherford',
    SCOTT = 'Scott',
    SEQUATCHIE = 'Sequatchie',
    SEVIER = 'Sevier',
    SHELBY = 'Shelby',
    SMITH = 'Smith',
    STEWART = 'Stewart',
    SULLIVAN = 'Sullivan',
    SUMNER = 'Sumner',
    TIPTON = 'Tipton',
    TROUSDALE = 'Trousdale',
    UNICOI = 'Unicoi',
    UNION = 'Union',
    VAN_BUREN = 'Van Buren',
    WARREN = 'Warren',
    WASHINGTON = 'Washington',
    WAYNE = 'Wayne',
    WEAKLEY = 'Weakley',
    WHITE = 'White',
    WILLIAMSON = 'Williamson',
    WILSON = 'Wilson',
}

export enum TX_CountyType {
    ANDERSON = 'Anderson',
    ANDREWS = 'Andrews',
    ANGELINA = 'Angelina',
    ARANSAS = 'Aransas',
    ARCHER = 'Archer',
    ARMSTRONG = 'Armstrong',
    ATASCOSA = 'Atascosa',
    AUSTIN = 'Austin',
    BAILEY = 'Bailey',
    BANDERA = 'Bandera',
    BASTROP = 'Bastrop',
    BAYLOR = 'Baylor',
    BEE = 'Bee',
    BELL = 'Bell',
    BEXAR = 'Bexar',
    BLANCO = 'Blanco',
    BORDEN = 'Borden',
    BOSQUE = 'Bosque',
    BOWIE = 'Bowie',
    BRAZORIA = 'Brazoria',
    BRAZOS = 'Brazos',
    BREWSTER = 'Brewster',
    BRISCOE = 'Briscoe',
    BROOKS = 'Brooks',
    BROWN = 'Brown',
    BURLESON = 'Burleson',
    BURNET = 'Burnet',
    CALDWELL = 'Caldwell',
    CALHOUN = 'Calhoun',
    CALLAHAN = 'Callahan',
    CAMERON = 'Cameron',
    CAMP = 'Camp',
    CARSON = 'Carson',
    CASS = 'Cass',
    CASTRO = 'Castro',
    CHAMBERS = 'Chambers',
    CHEROKEE = 'Cherokee',
    CHILDRESS = 'Childress',
    CLAY = 'Clay',
    COCHRAN = 'Cochran',
    COKE = 'Coke',
    COLEMAN = 'Coleman',
    COLLIN = 'Collin',
    COLLINGSWORTH = 'Collingsworth',
    COLORADO = 'Colorado',
    COMAL = 'Comal',
    COMANCHE = 'Comanche',
    CONCHO = 'Concho',
    COOKE = 'Cooke',
    CORYELL = 'Coryell',
    COTTLE = 'Cottle',
    CRANE = 'Crane',
    CROCKETT = 'Crockett',
    CROSBY = 'Crosby',
    CULBERSON = 'Culberson',
    DALLAM = 'Dallam',
    DALLAS = 'Dallas',
    DAWSON = 'Dawson',
    DE_WITT = 'De Witt',
    DEAF_SMITH = 'Deaf Smith',
    DELTA = 'Delta',
    DENTON = 'Denton',
    DICKENS = 'Dickens',
    DIMMIT = 'Dimmit',
    DONLEY = 'Donley',
    DUVAL = 'Duval',
    EASTLAND = 'Eastland',
    ECTOR = 'Ector',
    EDWARDS = 'Edwards',
    EL_PASO = 'El Paso',
    ELLIS = 'Ellis',
    ERATH = 'Erath',
    FALLS = 'Falls',
    FANNIN = 'Fannin',
    FAYETTE = 'Fayette',
    FISHER = 'Fisher',
    FLOYD = 'Floyd',
    FOARD = 'Foard',
    FORT_BEND = 'Fort Bend',
    FRANKLIN = 'Franklin',
    FREESTONE = 'Freestone',
    FRIO = 'Frio',
    GAINES = 'Gaines',
    GALVESTON = 'Galveston',
    GARZA = 'Garza',
    GILLESPIE = 'Gillespie',
    GLASSCOCK = 'Glasscock',
    GOLIAD = 'Goliad',
    GONZALES = 'Gonzales',
    GRAY = 'Gray',
    GRAYSON = 'Grayson',
    GREGG = 'Gregg',
    GRIMES = 'Grimes',
    GUADALUPE = 'Guadalupe',
    HALE = 'Hale',
    HALL = 'Hall',
    HAMILTON = 'Hamilton',
    HANSFORD = 'Hansford',
    HARDEMAN = 'Hardeman',
    HARDIN = 'Hardin',
    HARRIS = 'Harris',
    HARRISON = 'Harrison',
    HARTLEY = 'Hartley',
    HASKELL = 'Haskell',
    HAYS = 'Hays',
    HEMPHILL = 'Hemphill',
    HENDERSON = 'Henderson',
    HIDALGO = 'Hidalgo',
    HILL = 'Hill',
    HOCKLEY = 'Hockley',
    HOOD = 'Hood',
    HOPKINS = 'Hopkins',
    HOUSTON = 'Houston',
    HOWARD = 'Howard',
    HUDSON = 'Hudspeth',
    HUNT = 'Hunt',
    HUTCHINSON = 'Hutchinson',
    IRION = 'Irion',
    JACK = 'Jack',
    JACKSON = 'Jackson',
    JASPER = 'Jasper',
    JEFF_DAVIS = 'Jeff Davis',
    JEFFERSON = 'Jefferson',
    JIM_HOGG = 'Jim Hogg',
    JIM_WELLS = 'Jim Wells',
    JOHNSON = 'Johnson',
    JONES = 'Jones',
    KARNES = 'Karnes',
    KAUFMAN = 'Kaufman',
    KENDALL = 'Kendall',
    KENEDY = 'Kenedy',
    KENT = 'Kent',
    KERR = 'Kerr',
    KIMBLE = 'Kimble',
    KING = 'King',
    KINNEY = 'Kinney',
    KLEBERG = 'Kleberg',
    KNOX = 'Knox',
    LA_SALLE = 'La Salle',
    LAMAR = 'Lamar',
    LAMB = 'Lamb',
    LAMPASAS = 'Lampasas',
    LAVACA = 'Lavaca',
    LEE = 'Lee',
    LEON = 'Leon',
    LIBERTY = 'Liberty',
    LIMESTONE = 'Limestone',
    LIPSCOMB = 'Lipscomb',
    LIVE_OAK = 'Live Oak',
    LLANO = 'Llano',
    LOVING = 'Loving',
    LUBBOCK = 'Lubbock',
    LYNN = 'Lynn',
    MADISON = 'Madison',
    MARION = 'Marion',
    MARTIN = 'Martin',
    MASON = 'Mason',
    MATAGORDA = 'Matagorda',
    MAVERICK = 'Maverick',
    MCCULLOCH = 'Mcculloch',
    MCLENNAN = 'Mclennan',
    MCMULLEN = 'Mcmullen',
    MEDINA = 'Medina',
    MENARD = 'Menard',
    MIDLAND = 'Midland',
    MILAM = 'Milam',
    MILLS = 'Mills',
    MITCHELL = 'Mitchell',
    MONTAGUE = 'Montague',
    MONTGOMERY = 'Montgomery',
    MOORE = 'Moore',
    MORRIS = 'Morris',
    MOTLEY = 'Motley',
    NACOGDOCHES = 'Nacogdoches',
    NAVARRO = 'Navarro',
    NEWTON = 'Newton',
    NOLAN = 'Nolan',
    NUECES = 'Nueces',
    OCHILTREE = 'Ochiltree',
    OLDHAM = 'Oldham',
    ORANGE = 'Orange',
    PALO_PINTO = 'Palo Pinto',
    PANOLA = 'Panola',
    PARKER = 'Parker',
    PARMER = 'Parmer',
    PECOS = 'Pecos',
    POLK = 'Polk',
    POTTER = 'Potter',
    PRESIDIO = 'Presidio',
    Rains = 'Rains',
    RANDALL = 'Randall',
    REAGAN = 'Reagan',
    REAL = 'Real',
    RED_RIVER = 'Red River',
    REEVES = 'Reeves',
    REFUGIO = 'Refugio',
    ROBERTS = 'Roberts',
    ROBERTSON = 'Robertson',
    ROCKWALL = 'Rockwall',
    RUNNELS = 'Runnels',
    RUSK = 'Rusk',
    SABINE = 'Sabine',
    SAN_AUGUSTINE = 'San Augustine',
    SAN_JACINTO = 'San Jacinto',
    SAN_PATRICIO = 'San Patricio',
    SAN_SABA = 'San Saba',
    SCHLEICHER = 'Schleicher',
    Scurry = 'Scurry',
    Shackelford = 'Shackelford',
    Shelby = 'Shelby',
    Sherman = 'Sherman',
    Smith = 'Smith',
    Somervell = 'Somervell',
    Starr = 'Starr',
    Stephens = 'Stephens',
    Sterling = 'Sterling',
    Stonewall = 'Stonewall',
    Sutton = 'Sutton',
    Swisher = 'Swisher',
    Tarrant = 'Tarrant',
    Taylor = 'Taylor',
    Terrell = 'Terrell',
    Terry = 'Terry',
    Throckmorton = 'Throckmorton',
    Titus = 'Titus',
    Tom_Green = 'Tom Green',
    Travis = 'Travis',
    Trinity = 'Trinity',
    Tyler = 'Tyler',
    Upshur = 'Upshur',
    Upton = 'Upton',
    Uvalde = 'Uvalde',
    Val_Verde = 'Val Verde',
    Van_Zandt = 'Van Zandt',
    Victoria = 'Victoria',
    Walker = 'Walker',
    Waller = 'Waller',
    Ward = 'Ward',
    Washington = 'Washington',
    Webb = 'Webb',
    Wharton = 'Wharton',
    Wheeler = 'Wheeler',
    Wichita = 'Wichita',
    Wilbarger = 'Wilbarger',
    Willacy = 'Willacy',
    Williamson = 'Williamson',
    Wilson = 'Wilson',
    Winkler = 'Winkler',
    Wise = 'Wise',
    WOOD = 'Wood',
    YOAKUM = 'Yoakum',
    YOUNG = 'Young',
    ZAPATA = 'Zapata',
    ZAVALA = 'Zavala',
}

export enum UT_CountyType {
    BEAVER = 'Beaver',
    BOX_ELDER = 'Box Elder',
    CACHE = 'Cache',
    CARBON = 'Carbon',
    DAGGETT = 'Daggett',
    DAVIS = 'Davis',
    DUCHESNE = 'Duchesne',
    EMERY = 'Emery',
    GARFIELD = 'Garfield',
    GRAND = 'Grand',
    IRON = 'Iron',
    JUAB = 'Juab',
    KANE = 'Kane',
    MILLARD = 'Millard',
    MORGAN = 'Morgan',
    PIUTE = 'Piute',
    RICH = 'Rich',
    SALT_LAKE = 'Salt Lake',
    SAN_JUAN = 'San Juan',
    SANPETE = 'Sanpete',
    SEVIER = 'Sevier',
    SUMMIT = 'Summit',
    TOOELE = 'Tooele',
    UINTAH = 'Uintah',
    UTAH = 'Utah',
    WASATCH = 'Wasatch',
    WASHINGTON = 'Washington',
    WAYNE = 'Wayne',
    WEBER = 'Weber',
}

export enum VA_CountyType {
    ACCOMACK = 'Accomack',
    ALBEMARLE = 'Albemarle',
    ALEXANDRIA_CITY = 'Alexandria City',
    ALLEGHANY = 'Alleghany',
    AMELIA = 'Amelia',
    AMHERST = 'Amherst',
    APPOMATTOX = 'Appomattox',
    ARLINGTON = 'Arlington',
    AUGUSTA = 'Augusta',
    BATH = 'Bath',
    BEDFORD = 'Bedford',
    BLAND = 'Bland',
    BOTETOURT = 'Botetourt',
    BRISTOL_CITY = 'Bristol City',
    BRUNSWICK = 'Brunswick',
    BUCHANAN = 'Buchanan',
    BUCKINGHAM = 'Buckingham',
    BUENA_VISTA_CITY = 'Buena Vista City',
    CAMPBELL = 'Campbell',
    CAROLINE = 'Caroline',
    CARROLL = 'Carroll',
    CHARLES_CITY = 'Charles City',
    CHARLOTTE = 'Charlotte',
    CHARLOTTESVILLE_CITY = 'Charlottesville City',
    CHESAPEAKE_CITY = 'Chesapeake City',
    CHESTERFIELD = 'Chesterfield',
    CLARKE = 'Clarke',
    COLONIAL_HEIGHTS_CITY = 'Colonial Heights City',
    COVINGTON_CITY = 'Covington City',
    CRAIG = 'Craig',
    CULPEPER = 'Culpeper',
    CUMBERLAND = 'Cumberland',
    DANVILLE_CITY = 'Danville City',
    DICKENSON = 'Dickenson',
    DINWIDDIE = 'Dinwiddie',
    ESSEX = 'Essex',
    FAIRFAX = 'Fairfax',
    FAIRFAX_CITY = 'Fairfax City',
    FALLS_CHURCH_CITY = 'Falls Church City',
    FAUQUIER = 'Fauquier',
    FLOYD = 'Floyd',
    FLUVANNA = 'Fluvanna',
    FRANKLIN = 'Franklin',
    FRANKLIN_CITY = 'Franklin City',
    FREDERICK = 'Frederick',
    FREDERICKSBURG_CITY = 'Fredericksburg City',
    GALAX_CITY = 'Galax City',
    GILES = 'Giles',
    GLOUCESTER = 'Gloucester',
    GOOCHLAND = 'Goochland',
    GRAYSON = 'Grayson',
    GREENE = 'Greene',
    GREENSVILLE = 'Greensville',
    HALIFAX = 'Halifax',
    HAMPTON_CITY = 'Hampton City',
    HANOVER = 'Hanover',
    HARRISONBURG_CITY = 'Harrisonburg City',
    HENRICO = 'Henrico',
    HENRY = 'Henry',
    HIGHLAND = 'Highland',
    HOPEWELL_CITY = 'Hopewell City',
    ISLE_OF_WIGHT = 'Isle Of Wight',
    JAMES_CITY = 'James City',
    KING_AND_QUEEN = 'King And Queen',
    KING_GEORGE = 'King George',
    KING_WILLIAM = 'King William',
    LANCASTER = 'Lancaster',
    LEE = 'Lee',
    LEXINGTON_CITY = 'Lexington City',
    LOUDOUN = 'Loudoun',
    LOUISA = 'Louisa',
    LUNENBURG = 'Lunenburg',
    LYNCHBURG_CITY = 'Lynchburg City',
    MADISON = 'Madison',
    MANASSAS_CITY = 'Manassas City',
    MANASSAS_PARK_CITY = 'Manassas Park City',
    MARTINSVILLE_CITY = 'Martinsville City',
    MATHEWS = 'Mathews',
    MECKLENBURG = 'Mecklenburg',
    MIDDLESEX = 'Middlesex',
    MONTGOMERY = 'Montgomery',
    NELSON = 'Nelson',
    NEW_KENT = 'New Kent',
    NEWPORT_NEWS_CITY = 'Newport News City',
    NORFOLK_CITY = 'Norfolk City',
    NORTHAMPTON = 'Northampton',
    NORTHUMBERLAND = 'Northumberland',
    NORTON_CITY = 'Norton City',
    NOTTOWAY = 'Nottoway',
    ORANGE = 'Orange',
    PAGE = 'Page',
    PATRICK = 'Patrick',
    PETERSBURG_CITY = 'Petersburg City',
    PITTSYLVANIA = 'Pittsylvania',
    POQUOSON_CITY = 'Poquoson City',
    PORTSMOUTH_CITY = 'Portsmouth City',
    POWHATAN = 'Powhatan',
    PRINCE_EDWARD = 'Prince Edward',
    PRINCE_GEORGE = 'Prince George',
    PRINCE_WILLIAM = 'Prince William',
    PULASKI = 'Pulaski',
    RADFORD = 'Radford',
    RAPPAHANNOCK = 'Rappahannock',
    RICHMOND = 'Richmond',
    RICHMOND_CITY = 'Richmond City',
    ROANOKE = 'Roanoke',
    ROANOKE_CITY = 'Roanoke City',
    ROCKBRIDGE = 'Rockbridge',
    ROCKINGHAM = 'Rockingham',
    RUSSELL = 'Russell',
    SALEM = 'Salem',
    SCOTT = 'Scott',
    SHENANDOAH = 'Shenandoah',
    SMYTH = 'Smyth',
    SOUTHAMPTON = 'Southampton',
    SPOTSYLVANIA = 'Spotsylvania',
    STAFFORD = 'Stafford',
    STAUNTON_CITY = 'Staunton City',
    SUFFOLK_CITY = 'Suffolk City',
    SURRY = 'Surry',
    SUSSEX = 'Sussex',
    TAZEWELL = 'Tazewell',
    VIRGINIA_BEACH_CITY = 'Virginia Beach City',
    WARREN = 'Warren',
    WASHINGTON = 'Washington',
    WAYNESBORO_CITY = 'Waynesboro City',
    WESTMORELAND = 'Westmoreland',
    WILLIAMSBURG_CITY = 'Williamsburg City',
    WINCHESTER_CITY = 'Winchester City',
    WISE = 'Wise',
    WYTHE = 'Wythe',
    YORK = 'York',
}

export enum VT_CountyType {
    ADDISON = 'Addison',
    BENNINGTON = 'Bennington',
    CALEDONIA = 'Caledonia',
    CHITTENDEN = 'Chittenden',
    ESSEX = 'Essex',
    FRANKLIN = 'Franklin',
    GRAND_ISLE = 'Grand Isle',
    LAMOILLE = 'Lamoille',
    ORANGE = 'Orange',
    ORLEANS = 'Orleans',
    RUTLAND = 'Rutland',
    WASHINGTON = 'Washington',
    WINDHAM = 'Windham',
    WINDSOR = 'Windsor',
}

export enum WA_CountyType {
    ADAMS = 'Adams',
    ASOTIN = 'Asotin',
    BENTON = 'Benton',
    CHELAN = 'Chelan',
    CLALLAM = 'Clallam',
    CLARK = 'Clark',
    COLUMBIA = 'Columbia',
    COWLITZ = 'Cowlitz',
    DOUGLAS = 'Douglas',
    FERRY = 'Ferry',
    FRANKLIN = 'Franklin',
    GARFIELD = 'Garfield',
    GRANT = 'Grant',
    GRAYS_HARBOR = 'Grays Harbor',
    ISLAND = 'Island',
    JEFFERSON = 'Jefferson',
    KING = 'King',
    KITSAP = 'Kitsap',
    KITTITAS = 'Kittitas',
    KLICKITAT = 'Klickitat',
    LEWIS = 'Lewis',
    LINCOLN = 'Lincoln',
    MASON = 'Mason',
    OKANOGAN = 'Okanogan',
    PACIFIC = 'Pacific',
    PEND_OREILLE = 'Pend Oreille',
    PIERCE = 'Pierce',
    SAN_JUAN = 'San Juan',
    SKAGIT = 'Skagit',
    SKAMANIA = 'Skamania',
    SNOHOMISH = 'Snohomish',
    SPOKANE = 'Spokane',
    STEVENS = 'Stevens',
    THURSTON = 'Thurston',
    WAHKIAKUM = 'Wahkiakum',
    WALLA_WALLA = 'Walla Walla',
    WHATCOM = 'Whatcom',
    WHITMAN = 'Whitman',
    YAKIMA = 'Yakima',
}

export enum WI_CountyType {
    ADAMS = 'Adams',
    ASHLAND = 'Ashland',
    BARRON = 'Barron',
    BAYFIELD = 'Bayfield',
    BROWN = 'Brown',
    BUFFALO = 'Buffalo',
    BURNETT = 'Burnett',
    CALUMET = 'Calumet',
    CHIPPEWA = 'Chippewa',
    CLARK = 'Clark',
    COLUMBIA = 'Columbia',
    CRAWFORD = 'Crawford',
    DANE = 'Dane',
    DODGE = 'Dodge',
    DOOR = 'Door',
    DOUGLAS = 'Douglas',
    DUNN = 'Dunn',
    EAU_CLAIRE = 'Eau Claire',
    FLORENCE = 'Florence',
    FOND_DU_LAC = 'Fond Du Lac',
    FOREST = 'Forest',
    GRANT = 'Grant',
    GREEN = 'Green',
    GREEN_LAKE = 'Green Lake',
    IOWA = 'Iowa',
    IRON = 'Iron',
    JACKSON = 'Jackson',
    JEFFERSON = 'Jefferson',
    JUNEAU = 'Juneau',
    KENOSHA = 'Kenosha',
    KEWAUNEE = 'Kewaunee',
    LA_CROSSE = 'La Crosse',
    LAFAYETTE = 'Lafayette',
    LANGLADE = 'Langlade',
    LINCOLN = 'Lincoln',
    MANITOWOC = 'Manitowoc',
    MARATHON = 'Marathon',
    MARINETTE = 'Marinette',
    MARQUETTE = 'Marquette',
    MENOMINEE = 'Menominee',
    MILWAUKEE = 'Milwaukee',
    MONROE = 'Monroe',
    OCONTO = 'Oconto',
    ONEIDA = 'Oneida',
    OUTAGAMIE = 'Outagamie',
    OZAUKEE = 'Ozaukee',
    PEPIN = 'Pepin',
    PIERCE = 'Pierce',
    POLK = 'Polk',
    PORTAGE = 'Portage',
    PRICE = 'Price',
    RACINE = 'Racine',
    RICHLAND = 'Richland',
    ROCK = 'Rock',
    RUSK = 'Rusk',
    SAINT_CROIX = 'Saint Croix',
    SAUK = 'Sauk',
    SAWYER = 'Sawyer',
    SHAWANO = 'Shawano',
    SHEBOYGAN = 'Sheboygan',
    TAYLOR = 'Taylor',
    TREMPEALEAU = 'Trempealeau',
    VERNON = 'Vernon',
    VILAS = 'Vilas',
    WALWORTH = 'Walworth',
    WASHBURN = 'Washburn',
    WASHINGTON = 'Washington',
    WAUKESHA = 'Waukesha',
    WAUPACA = 'Waupaca',
    WAUSHARA = 'Waushara',
    WINNEBAGO = 'Winnebago',
    WOOD = 'Wood',
}

export enum WV_CountyType {
    BARBOUR = 'Barbour',
    BERKELEY = 'Berkeley',
    BOONE = 'Boone',
    BRAXTON = 'Braxton',
    BROOKE = 'Brooke',
    CABELL = 'Cabell',
    CALHOUN = 'Calhoun',
    CLAY = 'Clay',
    DODDRIDGE = 'Doddridge',
    FAYETTE = 'Fayette',
    GILMER = 'Gilmer',
    GRANT = 'Grant',
    GREENBRIER = 'Greenbrier',
    HAMPSHIRE = 'Hampshire',
    HANCOCK = 'Hancock',
    HARDY = 'Hardy',
    HARRISON = 'Harrison',
    JACKSON = 'Jackson',
    JEFFERSON = 'Jefferson',
    KANAWHA = 'Kanawha',
    LEWIS = 'Lewis',
    LINCOLN = 'Lincoln',
    LOGAN = 'Logan',
    MARION = 'Marion',
    MARSHALL = 'Marshall',
    MASON = 'Mason',
    MCDOWELL = 'Mcdowell',
    MERCER = 'Mercer',
    MINERAL = 'Mineral',
    MINGO = 'Mingo',
    MONONGALIA = 'Monongalia',
    MONROE = 'Monroe',
    MORGAN = 'Morgan',
    NICHOLAS = 'Nicholas',
    OHIO = 'Ohio',
    PENDLETON = 'Pendleton',
    PLEASANTS = 'Pleasants',
    POCAHONTAS = 'Pocahontas',
    PRESTON = 'Preston',
    PUTNAM = 'Putnam',
    RALEIGH = 'Raleigh',
    RANDOLPH = 'Randolph',
    RITCHIE = 'Ritchie',
    ROANE = 'Roane',
    SUMMERS = 'Summers',
    TAYLOR = 'Taylor',
    TUCKER = 'Tucker',
    TYLER = 'Tyler',
    UPSHUR = 'Upshur',
    WAYNE = 'Wayne',
    WEBSTER = 'Webster',
    WETZEL = 'Wetzel',
    WIRT = 'Wirt',
    WOOD = 'Wood',
    WYOMING = 'Wyoming',
}

export enum WY_CountyType {
    ALBANY = 'Albany',
    BIG_HORN = 'Big Horn',
    CAMPBELL = 'Campbell',
    CARBON = 'Carbon',
    CONVERSE = 'Converse',
    CROOK = 'Crook',
    FREMONT = 'Fremont',
    GOSHEN = 'Goshen',
    HOT_SPRINGS = 'Hot Springs',
    JOHNSON = 'Johnson',
    LARAMIE = 'Laramie',
    LINCOLN = 'Lincoln',
    NATRONA = 'Natrona',
    NIOBRARA = 'Niobrara',
    PARK = 'Park',
    PLATTE = 'Platte',
    SHERIDAN = 'Sheridan',
    SUBLETTE = 'Sublette',
    SWEETWATER = 'Sweetwater',
    TETON = 'Teton',
    UINTA = 'Uinta',
    WASHAKIE = 'Washakie',
    WESTON = 'Weston',
}